<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:24:33
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-02 09:53:06
 * @FilePath: \newsmartmapout\src\views\Watch.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:24:33
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-08-08 11:17:52
 * @FilePath: \newsmartmapout\src\views\Watch.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="watchBody">
    <!-- <div class="showRainBox" @click="showRainBoxPop">面雨量监测</div> -->
    <div class="rainBox" v-show="isShowRainBox">
      <div class="rainBoxTitle1">
        <div class="titleTetxBox">面雨量监测</div>
        <img src="../assets/close.png" @click="isShowRainBox=false" class="climg" alt />
      </div>
      <el-table :data="rainAreaData" style="width: 100%" height="250">
        <el-table-column prop="area" label="分区"></el-table-column>
        <el-table-column prop="h24" label="过去24h实测"></el-table-column>
        <el-table-column prop="hf24" label="未来24h预报"></el-table-column>
        <el-table-column prop="hf48" label="未来48h预报"></el-table-column>
        <el-table-column prop="hfall" label="未来72h预报"></el-table-column>
      </el-table>
      <el-table :data="rainAreaData2" style="width: 100%" height="250">
        <el-table-column prop="area" label="时段"></el-table-column>
        <el-table-column prop="h24" label="预报面雨量 " width="120"></el-table-column>
        <el-table-column prop="h48" label="对应级别" width="50"></el-table-column>
        <el-table-column prop="hf24" label="发布时间 "></el-table-column>
        <el-table-column prop="hf48" label="关键提示 "></el-table-column>
      </el-table>
    </div>
    <div id="map" style="width:100%;height:100%;position: absolute;"></div>
    <div class="optionSet2" v-show="!isShowLengdhBox" @click="isShowLengdhBox=true">显示图例</div>
    <!-- <div class="waringPrintPop"></div> -->
    <audio id="music" src="../assets/y2012.mp3" ref="mymusic" loop></audio>
    <el-dialog title="透明度调整" :visible.sync="showoptSetBox" width="30%">
      <el-slider v-model="optData" :format-tooltip="formatTooltip"></el-slider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showoptSetBox = false">取 消</el-button>
        <el-button type="primary" @click="changeoptDataHandel">确 定</el-button>
      </span>
    </el-dialog>
    <div class="warningInfoText" @click="closePlayMusic">
      <div class="warningInfoTextItem">
        <!-- <span>当前您所在区域正在发生红色暴雨过程,附近区域可能发生滑坡，请注意安全</span> -->
        <span>{{warningTextStr}}</span>
      </div>
    </div>
    <div class="leftConBox">
      <div class="msgBox" v-show="false">
        <div class="weatherTitle">
          <div class="weatherTitText">应对建议</div>
        </div>
        <div class="msgMainBox">
          <div class="msgMainBoxItem">1.今日降温明显，注意保暖</div>
          <div class="msgMainBoxItem">1.今日降温明显，注意保暖</div>
        </div>
      </div>
      <!-- <div class="msgMainBoxItem2">
        <div class="videoListboxItem">资料下载</div>
      </div>-->
      <div class="warningBoxf">
        <div class="weatherTitle">
          <!-- <div class="weatherTitText">预警管理</div> -->
          <div class="weatherTitText">历史统计</div>
          <!-- <div class="downLoadBtn" @click="downLoadData">表格下载</div> -->
        </div>
        <div class="warningMainBox">
          <div style="width:100%;height:100%; ">
            <div class="warnTableBoxHeaderBox">过去累积降水（单位:mm）</div>
            <div class="warnTableBoxheader22">
              <div class="warnTableBoxheader22Item1">站点</div>
              <div class="warnTableBoxheader22Item" @click.stop="sortTableData('h1')">1h</div>
              <div class="warnTableBoxheader22Item" @click.stop="sortTableData('h3')">6h</div>
              <div class="warnTableBoxheader22Item" @click.stop="sortTableData('h6')">12h</div>
              <div class="warnTableBoxheader22Item" @click.stop="sortTableData('h12')">24h</div>
              <div class="warnTableBoxheader22Item" @click.stop="sortTableData('h24')">48h</div>
            </div>
            <div class="tableCellBox">
              <vue-seamless-scroll
                :data="[1,2,3,2,5,4,5,8,5]"
                :class-option="classOption2"
                class="warp"
              >
                <div
                  :class="[index%2!=0?'warnTableBoxheader44':'warnTableBoxheader33']"
                  v-for="(item,index) in warningTableData"
                >
                  <div class="warnTableBoxheader22Item2">{{item.stationName}}</div>
                  <div class="warnTableBoxheader22Item">{{item.h1}}</div>
                  <div class="warnTableBoxheader22Item">{{item.h3}}</div>
                  <div class="warnTableBoxheader22Item">{{item.h6}}</div>
                  <div class="warnTableBoxheader22Item">{{item.h12}}</div>
                  <div class="warnTableBoxheader22Item">{{item.h24}}</div>
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>

      <div class="weatherBox">
        <div class="weatherTitle">
          <div class="weatherTitText">气象数据({{stationName}})</div>
        </div>
        <div class="weatherMainBox">
          <!-- <div class="weatherMainBoxItem">
            <div class="weatherText">温度</div>
            <div class="weatherinfotext">{{weatherdata.TEM}}°</div>
          </div>-->
          <!-- <div class="weatherMainBoxItem2">
            <div class="weatherText">湿度</div>
            <div class="weatherinfotext">{{weatherdata.RHU}}%</div>
           
          </div>-->
          <div class="weatherHounrListBox">
            <div class="weatherHounrListBoxItem">
              <div class="weatyherListTextBox">时间:</div>
              <div class="weatyherListTextBox temTetx">降水:</div>
              <div class="weatyherListTextBox temTetx">温度:</div>

              <div class="weatyherListTextBox temTetx">风速:</div>
            </div>
            <div class="weatherHounrListBoxItem" v-for="item in weatherTimeList">
              <div class="weatyherListTextBox">{{item.fxTime}}</div>
              <!-- <div class="weatyherListTextBox">
                <img :src="item.iconName" alt srcset />
              </div>-->
              <div class="weatyherListTextBox temTetx">{{item.pre}}mm</div>
              <div class="weatyherListTextBox temTetx">{{item.temp}}℃</div>
              <div class="weatyherListTextBox temTetx">{{item.humidity}}m/s</div>
            </div>
          </div>
          <div class="weatherMainBoxItem3">
            <div class="weatherMainBoxItemIconBox"></div>
            <div class="weatherMainBoxItemtextBox">
              <div class="weatherText">降水</div>
              <div class="weatherinfotext2">{{weatherdata.pre}}㎜</div>
            </div>
          </div>
          <div class="weatherMainBoxItem4">
            <div class="weatherMainBoxItemIconBox"></div>
            <div class="weatherMainBoxItemtextBox">
              <div class="weatherText">风力</div>
              <div class="weatherinfotext2">{{weatherdata.humidity}}m/s</div>
            </div>
          </div>
          <div class="weatherMainBoxItem5">
            <div class="weatherMainBoxItemIconBox"></div>
            <div class="weatherMainBoxItemtextBox">
              <div class="weatherText">温度</div>
              <div class="weatherinfotext2">{{weatherdata.temp}}℃</div>
            </div>

            <!-- <div class="weatherinfotext">---</div> -->
          </div>
          <div class="weatherMainBoxItem6">
            <div class="weatherMainBoxItemIconBox"></div>
            <div class="weatherMainBoxItemtextBox">
              <div class="weatherText">风向</div>
              <div class="weatherinfotext2">{{weatherdata.WIN_D_Avg_2mi}}°</div>
            </div>
          </div>
        </div>
      </div>
      <div class="videoBox">
        <div class="weatherTitle">
          <div class="weatherTitText">视频监控</div>
        </div>
        <div class="videoMainBox">
          <video
            id="mmiid"
            class="video-js vjs-big-play-centered vjs-fluid"
            controls
            preload="auto"
            width="100%"
            height="100%"
          ></video>
        </div>
        <div class="videoListbox">
          <el-select v-model="videoCHooseItem" class="checkList2Sec" placeholder="请选择" size="mini">
            <el-option v-for="item in 6" :value="item">视频监测站{{item}}</el-option>
          </el-select>
          <!-- <div class="videoListboxItem" v-for="item in 6">视频监测站{{item}}</div> -->
        </div>
      </div>
    </div>
    <div class="warningInfoBox" v-show="isShowwarningInfoBox">
      <div class="closeBoxImg" @click="isShowwarningInfoBox=false">
        <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
      </div>
      <div class="warningInfoTitle">{{waringIfoList.headline}}</div>
      <div class="warningInfoMainBox">
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">开始时间</div>
          <div class="itemRightBox">{{waringIfoList.effective}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">结束时间</div>
          <div class="itemRightBox">{{waringIfoList.expires}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">预警等级</div>
          <div class="itemRightBox">
            <el-tag
              size="small"
              :color="waringIfoList.severity"
              @click="openStrkHandell(waringIfoList)"
            >黄色预警</el-tag>
          </div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">次生灾害</div>
          <div class="itemRightBox">{{waringIfoList.text}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">影响面积</div>
          <div class="itemRightBox">{{waringIfoList.areanum}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">影响区域</div>
          <div class="itemRightBox">{{waringIfoList.geocode}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">负责人</div>
          <div class="itemRightBox">{{waringIfoList.tel}}</div>
        </div>
      </div>
    </div>

    <div class="rightConBox">
      <div class="warningBoxf22" @click.stop="gotoHunypage">
        <div class="weatherTitle">
          <!-- <div class="weatherTitText">预警管理</div> -->
          <div class="weatherTitText">本月气象预警</div>
        </div>
        <div class="warningMainBox33">
          <!-- <div class="warningMainBox33Item" v-for="item in 4">{{item}}</div> -->
          <div class="warningMainBox33Item">
            <div class="item1">{{warningcountData[0].value}}</div>
            <div class="item2">{{warningcountData[1].value}}</div>
            <div class="item3">{{warningcountData[2].value}}</div>
            <div class="item4">{{warningcountData[3].value}}</div>
          </div>
          <div class="waringtTitle">
            <div class="item1">蓝色预警</div>
            <div class="item2">黄色预警</div>
            <div class="item3">橙色预警</div>
            <div class="item4">红色预警</div>
          </div>
          <!-- <video
            muted
            autoplay="autoplay"
            preload="auto"
            playsinline
            loop
            src="../assets/warnBck.webm"
            type="video/webm"
            class="mywivewBox2"
          />-->
          <!-- <vue-seamless-scroll :data="waringList2" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem" v-for="item in waringList2" :key="item.time">
              <div>{{item.headline}}</div>
              <div class="warningBtn" @click="showwaringDelInfo(item)">详情</div>
            </div>
          </vue-seamless-scroll>-->
          <!-- <div id="roundEchartBox"></div> -->
        </div>
      </div>
      <!-- <div class="otherLaryerControllBox">
        <div class="layerChooseBoxTitle">
          <img src="../assets/Group_1321314869.png" alt />
          扩展图层
        </div>
        <div class="layerradioBox">
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>水系</div>
            <el-switch
              style="margin-left:10px"
              v-model="isSHowWarter"
              @change="extendCheckChange('水系')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>路网</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowRold"
              @change="extendCheckChange('路网')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>居民区</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowHouse"
              @change="extendCheckChange('居民区')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>水位</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowwater"
              @change="extendCheckChange('水位')"
            ></el-switch>
          </div>
          <div class="showRadioLayer" @click="isShowlayerradioBox=!isShowlayerradioBox">
            <i class="el-icon-caret-left" v-show="!isShowlayerradioBox"></i>
            <i class="el-icon-caret-right" v-show="isShowlayerradioBox"></i>
          </div>
        
        </div>
      </div>-->
      <div class="myLaryerControllBox">
        <!-- <div class="layerChooseBoxTitle">
          <img src="../assets/Group_1321314869.png" alt />
          图层检索
        </div>-->
        <div class="layerradioBox">
          <el-radio-group v-model="checkList2" @change="checkList2change" size="mini">
            <el-radio label="气象">气象</el-radio>
            <el-radio label="地质">地质</el-radio>
            <el-radio label="重点关注">重点关注</el-radio>
          </el-radio-group>
        </div>
        <div class="layerCHooseItemBox">
          <!-- <div class="testradiobox3" v-show="checkList2=='气象'">
            <div>自动站</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowStationLayer"
              @change="showStationDataTomap"
            ></el-switch>
          </div>-->
          <div class="testradiobox3" v-show="checkList2=='重点关注'">
            <div>地灾隐患点</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowPlaceWarning"
              @change="placeLayerChange('地灾隐患点')"
            ></el-switch>
          </div>
          <div class="testradiobox3" v-show="checkList2=='重点关注'">
            <div>重点观测点</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowPlaceWatch"
              @change="placeLayerChange('重点观测点')"
            ></el-switch>
          </div>
          <el-radio-group v-model="checkList" @change="showTypeChange" v-show="checkList2!='重点关注'">
            <div class="testRadio">
              <div class="testradiobox" v-for="item in checkListdata">
                <el-radio :label="item">{{item}}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="layerControllBox" v-show="false">
      <div class="layerControllTitle">图层检索</div>
      <div class="layerSelectBox">
        <el-radio-group
          v-model="checkList2"
          @change="checkList2change"
          size="mini"
          fill="#32DCFE"
          class="checkList2Sec"
          text-color="#32DCFE"
        >
          <el-radio label="气象">气象</el-radio>
          <el-radio label="地质">地质</el-radio>
          <!-- <el-radio label="水位">水位</el-radio> -->
        </el-radio-group>
      </div>
      <div class="layerSelectBox mylayerSelectBox">
        <el-select
          v-model="checkList"
          @change="showTypeChange"
          placeholder="请选择"
          size="mini"
          class="checkListSec"
          v-show="checkList2!='水位'"
        >
          <el-option v-for="item in checkListdata" :label="item" :value="item"></el-option>
        </el-select>
        <div class="openBottomlaryerbtn" v-show="!isShowOtherLayer" @click="isShowOtherLayer=true">
          扩展图层
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
      <div
        class="layerControllTitle"
        style="margin-top:15px"
        @click="isShowOtherLayer=false"
        v-if="isShowOtherLayer"
      >
        扩展图层
        <i class="el-icon-caret-top"></i>
      </div>
      <div class="layerSelectBox" v-if="isShowOtherLayer">
        <!-- <el-radio-group v-model="extendCheck" @change="extendCheckChange" size="mini" fill="#32DCFE" text-color="#32DCFE">
          <el-radio label="水系">水系</el-radio>
          <el-radio label="路网">路网</el-radio>
          <el-radio label="居民区">居民区</el-radio>
        </el-radio-group>-->
        <el-checkbox-group v-model="extendCheck" size="mini" @change="extendCheckChange">
          <el-checkbox label="水系"></el-checkbox>
          <el-checkbox label="路网"></el-checkbox>
          <el-checkbox label="居民区"></el-checkbox>
          <el-checkbox label="水位"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="timelineBox" v-show="false">
      <div class="playBtnBox" @click="palyHander">
        <img
          src="../assets/Group_1321314697.png"
          v-show="!this.isplaying"
          alt
          class="isplayingBtn"
          style
        />
        <img src="../assets/stop.png" v-show="this.isplaying" alt class="isplayingBtn" />
      </div>
      <div class="timeline">
        <el-slider
          v-model="timeLineData"
          show-stops
          :marks="marks"
          @change="changeMapGrid"
          :min="slidMindata"
          :max="slidMaxdata"
          size="mini"
        ></el-slider>
      </div>
    </div>
    <div class="listNewBox" v-show="isShowLengdhBox">
      <!-- <div class="optionSet" @click="showoptSetBox = true">透明度调整</div> -->
      <div class="optionSet" @click="isShowLengdhBox=false">隐藏图例</div>
      <div class="lendgenBox">
        <div class="lendgenBoxTitle">图例</div>
        <div class="showNumSwitch">
          <div>显示数值</div>
          <div>
            <el-switch v-model="isshownum" @change="isshownumchange"></el-switch>
          </div>
        </div>
        <div class="colorListBox">
          <div class="colorListBoxItem" v-for="item in ledgonList">
            <div class="colorBox" :style="{'backgroundColor':getrgb(item)}"></div>
            <div class="colorLable">{{item[0]}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class=""></div> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import macarons from "../map/macarons.json";
import WaterJson from "../map/511800.json";
import roldJson from "../map/rold.json";
import peoJson from "../map/peo.json";
import { unzip } from "../map/zip.js";
import sicdiz from "../map/neatogeo_sic.json";
import moment from "moment";
import md5 from "js-md5";
import waterPng from "../assets/water.png";
import sdpng from "../assets/sd.png";
import movePng from "../assets/Frame_5.png";
import movePng2 from "../assets/Frame_6.png";
import movePng3 from "../assets/Frame_7.png";
import movePng4 from "../assets/Frame_8.png";
import waringIcon from "../assets/waringIcon.png";
// import moment from "moment";
// import WaterJson from "../map/511800.json";
// import roldJson from "../map/rold.json";
// import peoJson from "../map/peo.json";
import vueSeamlessScroll from "vue-seamless-scroll";
import shimian from "../map/shimian.json";
import yingjing from "../map/lj.json";
import mingshan from "../map/511803.json";
import wind1 from "../assets/wind/wind1.png";
import wind2 from "../assets/wind/wind2.png";
import wind3 from "../assets/wind/wind3.png";
import wind4 from "../assets/wind/wind4.png";
import wind5 from "../assets/wind/wind5.png";
import wind6 from "../assets/wind/wind6.png";
import wind7 from "../assets/wind/wind7.png";
import wind8 from "../assets/wind/wind8.png";
import wind9 from "../assets/wind/wind9.png";
import wind10 from "../assets/wind/wind10.png";
import wind11 from "../assets/wind/wind11.png";
import wind12 from "../assets/wind/wind12.png";
import shibaPng from "../assets/shiuba3.png";
import china from "../map/china.json";
import heishui from "../map/513228.json";
import shuixi from "../map/shuixi.json";
import erdaoqianRain from "../map/erdaoqiao.json";
import zgdrain from "../map/zgdrain.json";
import sbgRain from "../map/sibangou.json";
import heishuixiang from "../map/heishuixiang.json";
import jsCookie from "js-cookie";
import Videojs from "video.js";
// import "../map/blinkmarker.js";
import { downloadXlsx } from "../map/xlsx";
import "video.js/dist/video-js.css";
// import "../map/blinkmarker.css";
import "videojs-flvjs-es6";
import "videojs-flash";
import { MapCreate, legendColor } from "../map/mapImport.js";
export default {
  data() {
    return {
      rainAreaData: [
        {
          area: "Ⅰ区（主源）",
          h24: "63.5",
          h48: "118.2 ",
          hf24: "78 ～ 95",
          hf48: "120 ～ 160 ",
          hf72: "45 ～ 70  ",
          hfall: "250 ～ 320"
        },
        {
          area: "Ⅱ区（左支）",
          h24: "57.8 ",
          h48: "105.4",
          hf24: "55 ～ 70",
          hf48: "90 ～ 125 ",
          hf72: "30 ～ 55 ",
          hfall: " 215 ～ 280"
        },
        {
          area: "Ⅲ区（右支)",
          h24: "71.3  ",
          h48: "132.0 ",
          hf24: "85 ～ 110",
          hf48: "140 ～ 180",
          hf72: " 50 ～ 80",
          hfall: " 285 ～ 360"
        },
        {
          area: "全流域面平均",
          h24: "64.2  ",
          h48: "118.9",
          hf24: "72 ～ 92",
          hf48: "118 ～ 155",
          hf72: " 42 ～ 68",
          hfall: " 250 ～ 315"
        }
      ],
      rainAreaData2: [
        {
          area: "07-18 08:00 ～ 07-19 08:00",
          h24: "72 ～ 92 mm",
          h48: "橙色",
          hf24: "07-17 15:30",
          hf48:
            "入库流量将升至 4 000 m³/s，建议提前 2 孔泄洪；山区注意山洪、滑坡。"
        },
        {
          area: " 07-19 08:00 ～ 07-20 08:00 ",
          h24: "118 ～ 155 mm",
          h48: "红色",
          hf24: "07-18 14:00",
          hf48: "洪峰可能达 8 500 m³/s，需腾空库容 1 亿 m³；下游镇区准备转移"
        },
        {
          area: " 07-20 08:00 ～ 07-21 08:00 ",
          h24: "42 ～ 68 mm",
          h48: "黄色",
          hf24: " 07-19 16:00",
          hf48: "雨势减弱，但仍需防范地质灾害滞后效应。"
        }
      ],
      isShowRainBox: false,
      chooseSDlatlon: [],
      chooseSdpringt: "",
      sdzList: [
        {
          name: "汉源县瀑布沟水电站",
          text:
            "总装机360万千瓦，是国家“十五”重点工程和西部大开发标志性工程，具有防洪、拦沙等综合效益",
          lon: 102.837547,
          lat: 29.209885
        },
        {
          name: "石棉县大岗山水电站",
          text:
            "总装机260万千瓦，是大渡河干流中游上段具有日调节性能的高坝大型水电站",
          lon: 102.36177647213513,
          lat: 29.229893497570806
        }
      ],
      sdzMakerLayer: null,
      DZlineLayer: null,
      weatherTimeList: [],
      warningcountData: [{}, {}, {}, {}],
      isShowPlaceWarning: true,
      isShowPlaceWatch: false,
      areaNameLayer: null,
      warningTextStr: "",
      stationListData: [],
      rowStyle: {
        color: "#fff",
        height: "39px",
        background: "#0F3440",
        marginBottom: "10px",
        opacity: "0.8",
        paddingTop: "10px",
        paddingBottom: "10px"
      },
      newwarningTableData: [],
      warningTableData: [],
      stationCenter: [103.009, 29.999],
      stationName: "雅安",
      isShowLengdhBox: false,
      classOption: {
        step: 0.2,
        singleWidth: 0,
        direction: 1
      },
      classOption2: {
        step: 0.2,
        singleWidth: 0,
        direction: 1
      },

      isShowStationLayer: true,
      isShowlayerradioBox: false,
      isSHowWarter: false,
      isShowRold: false,
      isShowHouse: false,
      isShowwater: false,
      isFirstPlay: true,
      areaPrintLayer: null,
      showoptSetBox: false,
      videoCHooseItem: "视频监测站1",
      isShowOtherLayer: false,
      waringList: [],
      waringList2: [],
      isshownum: false,
      tilePixelLayer: null,
      chooseGridData: null,
      ledgonList: legendColor["rain"],
      gridDataList: [],
      isShowWindLayer: false,
      userareaCode: "511800",
      checkList2: "气象",
      isplaying: false,
      slidMindata: 0,
      slidMaxdata: 119,
      timeLineData: 0,
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      waringIfoList: {
        headline: "石棉发布暴雨红色预警",
        startTime: "2024-03-28 12:00:00",
        endTime: "2024-03-28 16:00:00",
        level: "红色预警",
        text: "可能造成相关区域地质灾害（滑坡）",
        areanum: "242平方千米",
        area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
        tel: "182xxxxxxxx 王xx",
        leaveType: "red"
      },
      isSHowNum: false,
      typeCHoose: 3,

      showtype: "选项1",
      value: [30, 60],
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      sldPlayTimeer: null,
      checkListdata: ["雨量", "温度", "云图", "雷达",'全国降水','全国雷达'],
      checkList: "雨量",
      ledgonList: legendColor["rain"],
      weatherdata: {
        dis: 0.0001907141839999417,
        CityName: "雅安",
        cid: "CN101271701",
        cloud: 10,
        cond_code: 150,
        cond_txt: "晴",
        fl: -1,
        hum: 98,
        loc: 1703628240000,
        pcpn: 0,
        pres: 952,
        tmp: 4,
        vis: 2,
        wind_deg: 46,
        wind_dir: "东北风",
        wind_sc: "1",
        wind_spd: 5,
        tmp_max: 13,
        tmp_min: 3
      },
      extendCheck: [],
      waterLayer: null,
      roldLayer: null,
      peoLayer: null,
      optData: 100,
      isShowwarningInfoBox: false,
      chooseWraningData: {},
      getOpenLatLon: [0, 0],
      rainLayer:null,
    };
  },
  components: {
    vueSeamlessScroll
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map");
    this.getStationData2();
    let t = this;
    this.map.map.on("zoomend", () => {
      ////console.log(parseInt(20 / this.map.map.getZoom()));
      // ////console.log(map.getZoom());
      if (this.isShowWindLayer == true) {
        t.drawMakerTomap(
          this.chooseGridData.windS,
          this.chooseGridData.windD,
          parseInt(20 / this.map.map.getZoom()),
          this.chooseGridData
        );
      }
    });
    this.rainLayer = L.layerGroup().addTo(this.map.map);
    this.map.map.on("click", e => {
      console.log(e);
    });
    let layerJson = china;
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    // //console.log(myuserinfo);

    this.userareaCode = myuserinfo.areaCode;
    let style = {
      color: "#FCB042", //线颜色
      weight: 2, //线粗细
      // opacity: 1, //透明度
      opacity: 0,
      fillColor: "#2F5B00", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };
    let style2 = {
      color: "#FCB042", //线颜色
      weight: 5, //线粗细
      // opacity: 1, //透明度
      opacity: 1,
      fillColor: "#2F5B00", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };

    let areaNameList = [];

    if (this.userareaCode == "511800") {
      let myAreaLayer = L.geoJSON(china.features, {
        style: style2,

        onEachFeature: e => {
          console.log(2212121);
          let print = t.getPolygon(e.geometry.coordinates[0][0]);
          //console.log(print);
          //console.log(e.properties.name);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;width:100px;text-align:center;  font-weight: 800;
                  ">${e.properties.name}</div>`,
            className: "my-div-icon",
            iconSize: [50, 50],
            bgPos: [-50, -50]
          });
          let mymarker = L.marker(print, { icon: myIcon });
          areaNameList.push(mymarker);
        }
      }).addTo(this.map.map);
      this.areaNameLayer = L.layerGroup(areaNameList).addTo(this.map.map);
      // this.areaNameLayer.setZIndex(999);
      L.mask(china.features, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    } else if (this.userareaCode == "513228") {
      // console.log(heishui);
      L.geoJSON(shuixi.features, {
        color: "blue",
        weight: 10 //线粗细
      }).addTo(this.map.map);
      //         L.geoJSON(heishuixiang.features, {
      //    color: 'blue'
      // }).addTo(this.map.map)
      let myAreaLayer = L.geoJSON(heishuixiang.features, {
        style: style,

        onEachFeature: e => {
          // console.log(e.geometry.coordinates[0]);
          let print = t.getPolygon(e.geometry.coordinates[0]);
          // console.log(print);
          //console.log(e.properties.name);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;width:100px;text-align:center;  font-weight: 800;
                  ">${e.properties.Name}</div>`,
            className: "my-div-icon",
            iconSize: [50, 50],
            bgPos: [-50, -50]
          });
          let mymarker = L.marker(print, { icon: myIcon });
          areaNameList.push(mymarker);
        }
      }).addTo(this.map.map);
      this.areaNameLayer = L.layerGroup(areaNameList).addTo(this.map.map);
      L.mask(heishui.features, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
      let shuibaIcon = L.icon({
        iconUrl: shibaPng,
        iconAnchor: [15, 15],
        iconSize: [30, 30] // size of the icon
      });
      if (myuserinfo.country == "二道桥") {
        this.map.map.flyTo([32.20040745034925, 102.89337273356348], 13);
        // shibaPng
        let marker1= L.marker([32.20040745034925, 102.89337273356348], {
          icon: shuibaIcon
        }).addTo(this.map.map);
         marker1.on("click",(e)=>{
          // console.log(e.latlng);
          t.showSDpopBox2(e.latlng,'二道桥水电站')
        })
        L.geoJSON(erdaoqianRain.features, {
          color: "red",
          fillOpacity: 0,
          className: "dashLine"
        }).addTo(this.map.map);
      } else {
        this.map.map.flyTo([32.06956800106626, 103.0619676340287], 13);
        // shibaPng
        
       let marker1= L.marker([32.06956800106626, 103.0619676340287], {
          icon: shuibaIcon
        }).addTo(this.map.map); 
        marker1.on("click",(e)=>{
          // console.log(e.latlng);
          t.showSDpopBox2(e.latlng,'竹格多水电站')
        })
        let marker2=  L.marker([32.101140771401646, 102.76636678059353], {
          icon: shuibaIcon
        }).addTo(this.map.map); 
          marker2.on("click",(e)=>{
          console.log(e);
            t.showSDpopBox2(e.latlng,'四板沟水电站')
        })
        let marker3=   L.marker([32.20040745034925, 102.89337273356348], {
          icon: shuibaIcon
        }).addTo(this.map.map);
          marker3.on("click",(e)=>{
          console.log(e);
            t.showSDpopBox2(e.latlng,'二道桥水电站')
          
        }) 
        console.log(zgdrain.features);
         L.geoJSON(zgdrain.features, {
          color: "red",
          fillOpacity: 0,
          className: "dashLine"
        }).addTo(this.map.map);
          L.geoJSON(erdaoqianRain.features, {
          color: "red",
          fillOpacity: 0,
          className: "dashLine"
        }).addTo(this.map.map);
          L.geoJSON(sbgRain.features, {
          color: "red",
          fillOpacity: 0,
          className: "dashLine"
        }).addTo(this.map.map);
      }
    } else {
      china.features.map(item => {
        //console.log(item);
        if (item.properties.adcode == this.userareaCode) {
          layerJson = item;
          // //console.log(item);
          this.stationName = item.properties.name;
          this.stationCenter = item.properties.center;
        }
      });
      //console.log(this.stationCenter);
      this.getweatherData();
      let myAreaLayer = L.geoJSON(layerJson, { style: style }).addTo(
        this.map.map
      );
      L.mask(layerJson, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      // //console.log(this.map.map.getBounds(myAreaLayer));
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    }
    // this.map.map.panTo([ 32.21,102.90])
    this.getlineMarker();
    this.palyvideo(
      "https://sjtq.tianqi.cn/live/5107_7b9d4717b2f011ebb04e6c92bf487b62.m3u8"
    );
    this.getEchartsData();
    window.changeTableData = this.showBox2;
    window.showerea = this.showBox3;
    window.showSDdel = this.showSDdel;
    window.dzwringFun = this.dzwringFun;
    window.sdWeatherWarning = this.sdWeatherWarning;
    window.showareaRainPop = this.showareaRainPop;
    this.showSdzMaker();
    if (this.$store.state.isOpenStation) {
      this.getStationData();
    }
    // this.autoSroll("scroll_in2");
  },
  created() {
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    // //console.log(myuserinfo.areaCode);
    this.userareaCode = myuserinfo.areaCode;

    this.getGridData("rain");
    // this.getStationData();
    this.getWaringData();
    this.getTableData();
    this.getWarningText();
    this.getTimeWeatherData();
    this.placeLayerChange("地灾隐患点");

    // this.placeLayerChange("地灾隐患点")
    // setTimeout(() => {
    //   this.closePlayMusic();
    // }, 10000);
  },

  destroyed() {
    // //console.log("beforeDestory");
    this.map.map.remove();
    clearInterval(this.sctimer);
  },
  computed: {
    getSwitchState() {
      return this.$store.state.isOpenStation;
    },
    getopenState() {
      return this.$store.state.openStr;
    }
  },
  watch: {
    getSwitchState(e) {
      this.showStationDataTomap(e);
      // console.log(e);
    },
    getopenState(e) {
      console.log(211221);
      console.log(e);
      if (e.indexOf("水系") != -1) {
      }
      this.extendCheckChange(e);
      console.log(e);
    }
  },
  methods: {
    gotoHunypage() {
      this.$router.push({
        name: "response",
        params: {
          isopen: true
        }
      });
    },
    showareaRainPop() {
      this.isShowRainBox = true;
    },
    showRainBoxPop() {
      this.isShowRainBox = true;
    },
    sdWeatherWarning() {
      let popup = L.popup({})
        .setLatLng([this.chooseSDlatlon[0], this.chooseSDlatlon[1]])
        .setContent(
          `<div>
              <div style="margin-top:15px;text-align:center">气象预警评估</div>
               <div class="warningInfoTitle2" style="margin-top:15px">降水实况：
               <p>过去48小时，上游流域平均降雨量达82mm（较常年同期偏多180%），最大单站雨量142mm（石棉县 大山岗水电站）</p>
               <p>雷达回波显示，西南暖湿气流与低压槽持续盘踞，预计18-20日仍有暴雨到大暴雨（累计雨量120-180mm，局部250mm）</p>

               </div>
             <div class="warningInfoTitle2" style="margin-top:15px">水文数据:
               <p>入库流量已从850m³/s激增至2,300m³/s，水位涨幅达2.8m/24h</p>
               <p>土壤饱和度达95%，产流系数显著增加，预计洪峰流量将达8,500-10,000m³/s</p>

               </div>
              </div>`
        )
        .openOn(this.map.map);
    },
    dzwringFun() {
      console.log(this.chooseSDlatlon);
      let popup = L.popup({})
        .setLatLng([this.chooseSDlatlon[0], this.chooseSDlatlon[1]])
        .setContent(
          `<div>
          <div style="margin-top:15px;text-align:center">地震预警评估</div>
               <div class="warningInfoTitle2" style="margin-top:15px">区域地震活动性：位于龙门山地震带东段，历史记录 M≥5 级地震 7 次，最近为 1988 年 M5.9，震中距坝址 42 km;区域构造应力场以 NNE-SSW 向挤压为主，库区未发现全新世活动断裂</div>
               <div class="warningInfoTitle2" style="margin-top:15px">场地地震动参数：
               <p>1.基岩水平峰值加速度 PGA：0.21 g</p>
               <p>2.特征周期 Tg：0.35 s</p>
               <p>3.垂直向 PGA 取水平向 2/3</p>
               </div>
                <div class="warningInfoTitle2" style="margin-top:15px">地震地质灾害：库区 4 处堆积层滑坡体，方量 8–45 万 m³，地震工况稳定系数 1.18–1.23，需监测;坝址下游 1.2 km 存在古河道砂层液化可能，判定为轻微液化潜势</div>
              </div>`
        )
        .openOn(this.map.map);
    },
    showSdzMaker() {
      let moveIcon = L.icon({
        iconUrl: sdpng, //icon阴影图片路径

        iconSize: [25, 25] // size of the icon
      });
      let maekerList = [];
      let t = this;
      this.sdzList.map(item => {
        let mymarker = L.marker([item.lat, item.lon], { icon: moveIcon });
        mymarker.on("click", () => {
          t.showSDpopBox(item);
        });
        // .bindPopup(
        //   `
        //          <div class="warningInfoTitle2">${item.name}</div>
        //           <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px;margin-top:15px" onclick="showerea()">查看详情</div>
        //     `
        // )
        // .openPopup();
        maekerList.push(mymarker);
      });
      this.sdzMakerLayer = L.layerGroup(maekerList).addTo(this.map.map);
    },
    getTimeWeatherData() {
      // 103.049252,30.016292
      // this.$axios({
      //   method: "post",
      //   url: `https://www.moodsci.com/data/data/getHourlyDataByPosition?Longitude=103.049252&Latitude=30.016292`
      // }).then(res => {
      //   console.log(res.data);
      //   this.weatherTimeList = res.data.slice(1, 8).map(item => {
      //     item.fxTime = moment(item.fxTime, "YYYY-MM-DD HH:mm:ss")
      //       .subtract(1, "h")
      //       .format("HH:00");
      //     item.iconName = this.getIconName(item.icon);
      //     return item;
      //   });
      //   console.log(this.weatherTimeList);
      // });
      let formData = new FormData();

      formData.append("para", `{'datetime':'null','staname':'雅安'}`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/data/getKedaleHoursByStation`,
        data: formData
      }).then(res => {
        console.log("getWeatherData");
        console.log(res.data.datas[0]);
        //  this.weatherTimeList =[]
        let myarr = [];
        Object.keys(res.data.datas).forEach(item => {
          myarr.push({
            fxTime: moment(item, "YYYY-MM-DD HH:mm:ss").format("HH:mm"),
            temp: res.data.datas[item].TEM,
            humidity: res.data.datas[item].WIN_S_Avg_2mi,
            pre: res.data.datas[item].PRE_1h,
            WIN_D_Avg_2mi: res.data.datas[item].WIN_D_Avg_2mi
          });
          // console.log(item);
        });
        this.weatherdata = myarr[0];
        this.weatherTimeList = myarr.reverse();
      });
    },
    getIconName(code) {
      let weatherIconCode = code;
      if (code == 100 || code == 150) {
        weatherIconCode = 100;
      } else if (
        code == 101 ||
        code == 102 ||
        code == 103 ||
        code == 151 ||
        code == 152 ||
        code == 153
      ) {
        weatherIconCode = 101;
      } else if (
        code == 300 ||
        code == 301 ||
        code == 303 ||
        code == 350 ||
        code == 351
      ) {
        weatherIconCode = 300;
      } else if (code == 305 || code == 308 || code == 309 || code == 399) {
        weatherIconCode = 305;
      } else if (code == 314) {
        weatherIconCode = 306;
      } else if (code == 315) {
        weatherIconCode = 307;
      } else if (code == 316) {
        weatherIconCode = 310;
      } else if (code == 317) {
        weatherIconCode = 311;
      } else if (code == 313 || code == 318) {
        weatherIconCode = 312;
      } else if (code == 406 || code == 407 || code == 457) {
        weatherIconCode = 407;
      } else if (code == 405 || code == 499) {
        weatherIconCode = 400;
      } else if (code == 408) {
        weatherIconCode = 401;
      } else if (code == 409) {
        weatherIconCode = 402;
      } else if (code == 404 || code == 410 || code == 456) {
        weatherIconCode = 403;
      } else if (code == 500 || code == 509 || code == 514 || code == 514) {
        weatherIconCode = 501;
      } else if (code == 510 || code == 511 || code == 512 || code == 513) {
        weatherIconCode = 502;
      }
      return require(`../assets/weather/weather${weatherIconCode}.gif`);
    },
    placeLayerChange(e) {
      if (e == "地灾隐患点") {
        if (this.isShowPlaceWarning) {
          // this.checkList = "地灾隐患点";
          this.getDangerDataList("地灾隐患点");
          this.isShowPlaceWatch = false;
        } else {
          if (this.movePlaceLayer != null) {
            this.map.map.removeLayer(this.movePlaceLayer);
            this.movePlaceLayer = null;
          }
        }
      } else {
        if (this.isShowPlaceWatch) {
          // this.checkList = "重点观测点";
          this.getDangerDataList("重点观测点");
          this.isShowPlaceWarning = false;
        } else {
          if (this.movePlaceLayer != null) {
            this.map.map.removeLayer(this.movePlaceLayer);
            this.movePlaceLayer = null;
          }
        }
      }
    },
    getPolygon(pList) {
      var area = 0;
      var x = 0;
      var y = 0;
      for (var i = 1; i <= pList.length; i++) {
        var lat = pList[i % pList.length][0];
        var lng = pList[i % pList.length][1];
        var nextLat = pList[i - 1][0];
        var nextLng = pList[i - 1][1];
        var temp = (lat * nextLng - lng * nextLat) / 2;
        area += temp;
        x += (temp * (lat + nextLat)) / 3;
        y += (temp * (lng + nextLng)) / 3;
      }
      x = x / area;
      y = y / area;
      return [y, x];
    },
    downLoadData() {
      // import("@/vendor/Export2Excel").then(excel => {
      //   const tHeader = ["stationName", "h1", "h3", "h6", "h12", "h24"];
      //   const data = warningTableData;
      //   excel.export_json_to_excel({
      //     header: tHeader, //表头 必填
      //     data, //具体数据 必填
      //     filename: "excel-list", //非必填
      //     autoWidth: true, //非必填
      //     bookType: "xlsx" //非必填
      //   });
      // });
      let datalist = []; // 需要导出的表格数据
      datalist.push([
        "站名",
        "站号",
        "1小时降水（单位:mm）",
        "3小时降水（单位:mm）",
        "6小时降水（单位:mm）",
        "12小时降水（单位:mm）",
        "24小时降水（单位:mm）"
      ]);

      // this.list 获取后台接口数据
      this.warningTableData.forEach((item, index) => {
        // 拼接excel表格数据
        datalist.push([
          item.stationName,
          item.station,
          item.h1,
          item.h3,
          item.h6,
          item.h12,
          item.h24
        ]);
      });
      downloadXlsx(datalist, "累积降水表.xlsx");
    },
    sortTableData(type) {
      //console.log(type);
      let mynewarr = JSON.parse(JSON.stringify(this.warningTableData));

      mynewarr.sort((a, b) => {
        // //console.log(b[type].slice(0, -1));

        // return Number(b[type].slice(0, -1)) - Number(a[type].slice(0, -1));
        return Number(b[type]) - Number(a[type]);
      });
      //console.log(mynewarr);
      this.warningTableData = mynewarr;
    },
    getWarningText() {
      this.$axios({
        method: "post",
        url: `
      http://120.79.183.250:3099/warn/warn`
      }).then(res => {
        //console.log(res.data.datas);
        this.warningTextStr = res.data.datas;
      });
    },
    openDataPop(data) {
      //console.log(this.stationListData);
      //console.log(data);
      let newStationList = JSON.parse(JSON.stringify(this.stationListData));
      let getData = newStationList.filter(item => {
        return item.Station_Id_C == data.station;
      });
      //console.log(getData);
      // //console.log([getData.Lat, getData.Lon]);
      if (getData.length != 0) {
        let popup = L.popup({
          autoPanPaddingBottomRight: L.point(600, 300),
          autoPanPaddingTopLeft: L.point(600, 300)
        })
          .setLatLng([getData[0].Lat, getData[0].Lon])
          .setContent(
            `<div>
              <p>站号：${data.station}</p>
              <p>站名：${data.stationName}</p>
              <p>1小时累积降水：${data.h1}mm</p>
              <p>3小时累积降水：${data.h3}mm</p>
              <p>6小时累积降水：${data.h6}mm</p>
              <p>12小时累积降水：${data.h12}mm</p>
              <p>24小时累积降水：${data.h24}mm</p>
              </div>`
          )
          .openOn(this.map.map);
      } else {
        this.$message({
          showClose: true,
          message: "站点未开放",
          offset: 100
        });
      }
    },
    showBox3() {
      this.$message({
        showClose: true,
        message: "暂未上线",
        offset: 100
      });
    },
    showBox2() {
      //console.log(this.getOpenLatLon);
      let myNewData = {
        latlng: {
          lng: this.getOpenLatLon[1],
          lat: this.getOpenLatLon[0]
        }
      };
      //console.log(myNewData);
      this.filterTableData(myNewData);
    },
    filterTableData(data) {
      const loading = this.$loading({
        lock: true,
        text: "查询中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      //console.log(data);
      this.$axios({
        method: "get",
        url: ` https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getStationByHidstation&Longitude=${data.latlng.lng}&Latitude=${data.latlng.lat}`
      })
        .then(res => {
          //console.log(res.data.dataList[0]);
          let stationId = res.data.dataList[0].Station_Id_C;
          //console.log(this.newwarningTableData);
          //console.log(stationId);
          let myNewArr = JSON.parse(JSON.stringify(this.newwarningTableData));
          let mydata = myNewArr.filter(item => {
            // //console.log(item.station);
            return item.station == stationId;
          });
          //console.log(mydata);
          if (mydata.length != 0) {
            let popup = L.popup({
              autoPanPaddingBottomRight: L.point(600, 0)
            })
              .setLatLng([data.latlng.lat, data.latlng.lng])
              .setContent(
                `<div>
              <p>站号：${mydata[0].station}</p>
                <p>站名：${mydata[0].stationName}</p>
              <p>1小时累积降水：${mydata[0].h1}mm</p>
              <p>3小时累积降水：${mydata[0].h3}mm</p>
              <p>6小时累积降水：${mydata[0].h6}mm</p>
              <p>12小时累积降水：${mydata[0].h12}mm</p>
              <p>24小时累积降水：${mydata[0].h24}mm</p>
              </div>`
              )
              .openOn(this.map.map);
          } else {
            this.$message({
              showClose: true,
              message: "无数据",
              offset: 100
            });
          }
          loading.close();
          // this.warningTableData = mydata;
        })
        .catch(() => {
          loading.close();
        });
    },
    getTableData() {
      let formData = new FormData();

      formData.append(
        "para",
        `{"datetime":"${moment().format("YYYY-MM-DD 00:00:00")}"}`
      );
      // formData.append("para", `{"datetime":"2024-07-20 00:00:00"}`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/data/getKedaleCountHours`,
        data: formData
      })
        .then(res => {
          //console.log(res.data.datas);
          let arr = [];
          for (const key in res.data.datas) {
            // //console.log(key);
            // //console.log(res.data.datas[key]);

            let myData = res.data.datas[key];
            let myarr = myData.split(",");
            arr.push({
              station: key,
              stationName: myarr[0],
              h1: myarr[1],
              h3: myarr[2],
              h6: myarr[3],
              h12: myarr[4],
              h24: myarr[5]
            });
          }
          // //console.log(arr);
          this.warningTableData = arr;
          this.newwarningTableData = arr;
          // res.data.datas.map((item)=>{

          //   //console.log( Object.keys(object1));
          //   // arr.push({
          //   //   stationNum:item
          //   // })
          // })
          // this.msgListData = res.data.dataList;
        })
        .catch(() => {});
    },
    getEchartsData() {
      let code = 5118;
      if (this.userareaCode == 511800) {
        code = 5118;
      } else {
        code = this.userareaCode;
      }
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanWarnCount&starttime=${moment()
          .subtract(30, "d")
          .format("YYYY-MM-DD HH:00:00")}&adcode=${code}`
      })
        .then(res => {
          console.log(res.data.dataList);
          let mydata = [];

          res.data.dataList.map(item => {
            //console.log(item);
            mydata.push({ value: item.cout, name: item.type });
          });
          console.log(mydata);
          this.warningcountData = mydata;
          // var chartDom = document.getElementById("roundEchartBox");
          // echarts.registerTheme("macarons", macarons);
          // var myChart = echarts.init(chartDom, "macarons");
          // let option = {
          //   tooltip: {
          //     trigger: "item"
          //   },
          //   legend: {
          //     orient: "vertical",
          //     x: "right", //可设定图例在左、右、居中
          //     y: "center",
          //     textStyle: {
          //       color: "white" // 图例文字颜色
          //     },
          //     data: mydata,
          //     formatter: function(name) {
          //       //通过name获取到数组对象中的单个对象
          //       let singleData = mydata.filter(function(item) {
          //         return item.name == name;
          //       });
          //       return name + " | " + singleData[0].value + "次";
          //       //console.log(name);
          //     }
          //   },
          //   series: [
          //     {
          //       center: ["35%", "50%"],
          //       name: "",
          //       type: "pie",
          //       radius: ["50%", "90%"],
          //       avoidLabelOverlap: false,
          //       itemStyle: {
          //         borderRadius: 10,
          //         borderColor: "#fff",
          //         borderWidth: 1,
          //         normal: {
          //           color: function(colors) {
          //             var colorList = ["blue", "yellow", "orange", "red"];
          //             return colorList[colors.dataIndex];
          //           }
          //         }
          //       },
          //       label: {
          //         show: false,
          //         position: "center"
          //       },
          //       emphasis: {
          //         label: {
          //           show: true,
          //           fontSize: 40,
          //           fontWeight: "bold"
          //         }
          //       },
          //       labelLine: {
          //         show: false
          //       },
          //       data: mydata
          //     }
          //   ]
          // };

          // option && myChart.setOption(option);
        })
        .catch(() => {
          console.log(21212);
        });
    },
    getDangerDataList(str) {
      if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      let formData = new FormData();

      let myUrl = `https://www.moodsci.com/data/data/getYaanHiddenData`;

      if (str == "地灾隐患点") {
        myUrl = `https://www.moodsci.com/data/data/getYaanHiddenData`;
        formData.append("para", `{"datetime":"null"}`);
      } else {
        myUrl =
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanZdqy";
      }
      this.$axios({
        method: "post",
        url: myUrl,
        data: formData
      })
        .then(res => {
          // console.log(res.data.datas.DS);
          let myWarningListData = [];
          let latStr = "lat";
          let lonStr = "lon";

          if (str == "地灾隐患点") {
            myWarningListData = res.data.datas.DS;
            latStr = "lat";
            lonStr = "lon";
          } else {
            myWarningListData = res.data.dataList;
            latStr = "Lat";
            lonStr = "Lon";
          }

          let markerList = [];
          let moveIcon = L.icon({
            iconUrl: waringIcon, //icon阴影图片路径

            iconSize: [25, 25] // size of the icon
          });
          // //console.log(myWarningListData);
          let t = this;
          myWarningListData.map(item => {
            console.log(item[latStr]);

            let myMarker = L.marker([item[latStr], item[lonStr]], {
              icon: moveIcon
            });
            myMarker.on("click", () => {
              // //console.log(item);

              if (str == "地灾隐患点") {
                t.showPopulTomapHaveData(item);
              } else {
                t.showPopulTomap(item);
              }
            });
            // item.PRE_1h = 6;
            if (str == "地灾隐患点") {
              if (item.PRE_1h >= 5) {
                markerList.push(
                  L.blinkMarker([item[latStr], item[lonStr]], {
                    iconSize: [30, 30],
                    color: "red",
                    speedTime: 0.5,
                    level: 3
                  })
                );
              }
            }
            markerList.push(myMarker);
          });

          this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
        })
        .catch(() => {});
    },
    showSDdel() {
      console.log(2212121);
      console.log(this.chooseSdpringt);
      let routeData = this.$router.resolve({
        path: "/waringpage",
        query: { id: this.chooseSdpringt }
      });
      window.open(routeData.href, "_blank");
    },
    showSDpopBox(data) {
      this.chooseSDlatlon = [data.lat, data.lon];
      this.chooseSdpringt = data.name;
      let htmlStr = `
                   <div class="warningInfoTitle2" style="margin-top:15px">水电站名称：${data.name}</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">水电站介绍：${data.text}</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">地震防范评估：暂无</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">气象预警评估：暂无</div>
               
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px;margin-top:15px" onclick="showSDdel()">查看详情</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="dzwringFun()">地震危险性分析</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="sdWeatherWarning()">气象预警评估</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="showareaRainPop()">面雨量监测</div>
              `;
      let popup = L.popup({})
        .setLatLng([data.lat, data.lon])
        .setContent(htmlStr)
        .openOn(this.map.map);
    },
     showSDpopBox2(data,name) {
      this.chooseSDlatlon = [data.lat, data.lng];
      this.chooseSdpringt =name;
      let htmlStr = `
                   <div class="warningInfoTitle2" style="margin-top:15px">水电站名称：${name}</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">经度：${ data.lng.toFixed(3)}</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">纬度：${ data.lat.toFixed(3)}</div>

                   <div class="warningInfoTitle2" style="margin-top:15px">地震防范评估：暂无</div>
                   <div class="warningInfoTitle2" style="margin-top:15px">气象预警评估：暂无</div>
               
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px;margin-top:15px" onclick="showSDdel()">查看详情</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="dzwringFun()">地震危险性分析</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="sdWeatherWarning()">气象预警评估</div>
                    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:100px;height:30px;margin-top:15px" onclick="showareaRainPop()">面雨量监测</div>
              `;
      let popup = L.popup({})
        .setLatLng([data.lat, data.lng])
        .setContent(htmlStr)
        .openOn(this.map.map);
    },
    showPopulTomapHaveData(data) {
      console.log(data);
      this.getOpenLatLon = [data.lat, data.lon];
      let htmlStr = `
          <div style="width:200px">
          <div style="width:100%">
            <p>站名：${data.Name}</p>
            <p>区县：${data.Country}</p>
            <p>数据时间：${data.Datetime}</p>
            <p>风向：${data.WIN_D_Avg_2mi}</p>
            <p>风力：${data.WIN_S_Avg_2mi}级</p>
            <p>降水：${data.PRE_1h}mm</p>
             <p>湿度：${data.PRE_1h == 999999 ? "无监测" : data.PRE_1h}</p>
             <p>负责人名称：${data.fzName}</p>
             
             <p>检查人名称：${data.jcName}</p>
            
          </div>
      

   <div style="display: flex;width:100%;justify-content: space-around;">
    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px" onclick="showerea()">历史同期</div>
     <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px" onclick="changeTableData()">历史统计</div>
      </div>
          
          </div>
        
        `;

      let popup = L.popup({
        autoPanPaddingBottomRight: L.point(600, 0)
      })
        .setLatLng([data.lat, data.lon])
        .setContent(htmlStr)
        .openOn(this.map.map);
      // loading.close();
    },
    showPopulTomap(data) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      //// //console.log(data);
      this.$axios({
        method: "post",
        url: `
      http://120.79.183.250:3099/data/getActualElementsByPosition?Longitude=${data.Lon}&Latitude=${data.Lat}`
      })
        .then(res => {
          // //console.log(res.data[0]);
          this.getOpenLatLon = [data.Lat, data.Lon];
          let htmlStr = `
          <div style="width:180px">
          <div style="display: flex;flex-wrap: wrap;  justify-content: space-between;width:100%">
            <p style="width:45%">天气：${res.data[0].cond_txt}</p>
        <p style="width:45%">温度：${res.data[0].tmp}℃</p>
        <p style="width:45%">降水：${res.data[0].pcpn}㎜</p>
        <p style="width:45%">湿度：${res.data[0].hum}%</p>
        <p style="width:45%">风速：${res.data[0].wind_spd}m/s</p>
          <p style="width:45%">风向：${res.data[0].wind_dir}</p>
        <p style="width:50%">气压：${res.data[0].pres}hPa</p>
     </div>
      

   <div style="display: flex;width:100%;justify-content: space-around;">
    <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px" onclick="showerea()">历史同期</div>
     <div style="color:white;border: 1px solid #14C7DF;background-color:#12262B;border-radius: 5px;text-align:center;line-height:30px;width:80px;height:30px" onclick="changeTableData()">历史统计</div>
      </div>
          
          </div>
        
        `;

          let popup = L.popup({
            autoPanPaddingBottomRight: L.point(600, 0)
          })
            .setLatLng([data.Lat, data.Lon])
            .setContent(htmlStr)
            .openOn(this.map.map);
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    showStationDataTomap(e) {
      console.log(e);
      if (e) {
        this.getStationData();
      } else {
        if (this.areaPrintLayer != null) {
          this.map.map.removeLayer(this.areaPrintLayer);
          this.areaPrintLayer = null;
        }
      }
    },
    autoSroll(Id) {
      // flag 为true时停止滚动
      var flag = false;
      // 定时器
      let t = this;
      function roll() {
        var h = -1;
        t.sctimer = setInterval(function() {
          flag = true;
          //获取当前滚动条高度
          var current = document.getElementById(Id).scrollTop;
          if (current == h) {
            //滚动到底端,返回顶端
            h = 0;
            document.getElementById(Id).scrollTop = h + 1;
          } else {
            //以25ms/3.5px的速度滚动
            h = current;
            document.getElementById(Id).scrollTop = h + 1;
          }
        }, 50);
      }
      // setTimeout(function() {
      //滚动区域内单击鼠标 滚动暂停 再次点击鼠标 继续滚动
      document.getElementById(Id).onclick = () => {
        // //////console.log("点击了", timer, flag);
        if (flag) {
          flag = false;
          clearInterval(t.sctimer);
        } else {
          roll();
        }
      };
      roll();
      // }, 2000);
    },
    closePlayMusic() {
      let audio = this.$refs.mymusic;
      this.isFirstPlay = !this.isFirstPlay;

      if (this.isFirstPlay) {
        audio.pause();
      } else {
        audio.play();
      }
    },
    getrabColor(data) {
      return `rgba(${data[0]},${data[1]},${data[2]},1)`;
    },
    getStationData() {
      let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
      if (this.areaPrintLayer != null) {
        this.map.map.removeLayer(this.areaPrintLayer);
        this.areaPrintLayer = null;
      }
      let markerListData = [];
      let formData = new FormData();
      formData.append(
        "para",
        `{"datetime":"null","cnty":"${myuserinfo.country}"}`
      );
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/data/getKedaleHours`,
        data: formData
      })
        .then(res => {
          // //console.log(res);
          var greenIcon = L.icon({
            iconUrl: waterPng, //icon阴影图片路径

            iconSize: [32, 32] // size of the icon
          });
          // //console.log(res.data.datas);
          if (res.data.datas == null) return;
          this.stationListData = res.data.datas.DS;
          let myNewStaNum = 56373;
          if (this.userareaCode == 511822) {
            myNewStaNum = 56373;
          } else if (this.userareaCode == 511824) {
            myNewStaNum = 56378;
          }
          res.data.datas.DS.map(item => {
            if (item.Station_Id_C == myNewStaNum) {
              //console.log(item);
              // this.weatherdata = item;
            }
            // ////console.log(item.Lon, item.Lon);
            let color = "";
            // //console.log(item.PRE_1h);
            legendColor["rain"].map(item2 => {
              // //console.log(item2[0]);
              if (item.PRE_1h >= item2[0]) {
                //console.log(item2);

                if (item.PRE_1h == 999999) {
                  color = "white";
                } else {
                  color = this.getrabColor(item2[1]);
                }
              }
            });
            // let color = this.getrabColor(item);
            if (item.Lon != undefined && item.Lat != undefined) {
              // ////console.log(item);
              markerListData.push(
                L.circleMarker([item.Lat, item.Lon], {
                  radius: 5,
                  color: "black",
                  fillColor: color,
                  fillOpacity: 1
                })
                  .bindPopup(
                    `
                   <div class="warningInfoTitle2">站点数据</div>
                   <p>站点名称：${item.Station_Name}</p>
              <p>站点编号：${item.Station_Id_C}</p>
              <p>城市名称：${item.City}</p>
              <p>区县名称：${item.Cnty}</p>
              <p>监测时间：${item.Datetime}</p>
              <p>平均温度：${item.TEM == 999999 ? "无监测" : item.TEM + "℃"}</p>
            
             
              <p>一小时降水量：${
                item.PRE_1h == 999999 ? "0" : item.PRE_1h + "㎜"
              }</p>
               <p>湿度：${item.RHU == 999999 ? "无监测" : item.RHU + "%"}</p>
               <p>气压：${item.PRS == 999999 ? "无监测" : item.PRS + "hPa"}</p>
               <p>风速：${
                 item.WIN_S_Avg_2mi == 999999
                   ? "无监测"
                   : item.WIN_S_Avg_2mi + "米每秒"
               }</p>
                <p>风向：${
                  item.WIN_D_Avg_2mi == 999999 ? "无监测" : item.WIN_D_Avg_2mi
                }</p>
                  
              `
                  )
                  .openPopup()
              );
            }
          });
          this.areaPrintLayer = L.layerGroup(markerListData).addTo(
            this.map.map
          );
        })
        .catch(() => {});
    },
    getStationData2() {
      let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
      if (this.areaPrintLayer != null) {
        this.map.map.removeLayer(this.areaPrintLayer);
        this.areaPrintLayer = null;
      }
      let markerListData = [];
      let formData = new FormData();
      formData.append(
        "para",
        `{"datetime":"null","cnty":"${myuserinfo.country}"}`
      );
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/data/getKedaleHours`,
        data: formData
      })
        .then(res => {
          // //console.log(res);
          var greenIcon = L.icon({
            iconUrl: waterPng, //icon阴影图片路径

            iconSize: [32, 32] // size of the icon
          });
          // //console.log(res.data.datas);
          if (res.data.datas == null) return;
          this.stationListData = res.data.datas.DS;
          let myNewStaNum = 56373;
          if (this.userareaCode == 511822) {
            myNewStaNum = 56373;
          } else if (this.userareaCode == 511824) {
            myNewStaNum = 56378;
          }
          res.data.datas.DS.map(item => {
            if (item.Station_Id_C == myNewStaNum) {
              //console.log(item);
              // this.weatherdata = item;
            }
            // ////console.log(item.Lon, item.Lon);
          });
          this.areaPrintLayer = L.layerGroup(markerListData).addTo(
            this.map.map
          );
        })
        .catch(() => {});
    },
    changeoptDataHandel() {
      ////console.log(this.optData);
      // //////console.log(this.optData / 100);

      // if (this.checkList == "雨量") {
      //   this.getGridData("pre");
      // } else if (this.checkList == "温度") {
      //   this.getGridData("tem");
      // } else if (this.checkList == "大风") {
      //   this.getGridData("wind_s");
      // }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      this.showoptSetBox = false;
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }

      let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));
      ledcolorList.map((item, index) => {
        //////console.log(index);
        if (index == 0) {
          return (item[1][3] = 0);
        } else {
          return (item[1][3] = this.optData / 400);
        }
      });
      ////console.log(ledcolorList);
      ////console.log(type);
      if (type != "wind") {
        let dataList = [];
        if (type == "radar") {
          dataList = this.gridDataList[this.timeLineData].datas.map(item => {
            return Number(item);
          });
        } else {
          dataList = this.gridDataList[this.timeLineData].datas
            .split(",")
            .map(item => {
              return Number(item);
            });
        }
        let t = this;
        this.tilePixelLayer = L.tilePixelLayer({
          newData: dataList,
          data: this.gridDataList[this.timeLineData],
          gradient: ledcolorList,
          clickEvt: function(e, gridValue) {
            console.log(e, gridValue);
            // t.filterTableData(e);
            let popup = L.popup({
              autoPanPaddingBottomRight: L.point(600, 0)
            })
              .setLatLng([e.latlng.lat, e.latlng.lng])
              .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
              .openOn(t.map.map);
          }
        });

        this.map.map.addLayer(this.tilePixelLayer);
      } else {
        this.drawMakerTomap(
          this.gridDataList[this.timeLineData].windS,
          this.gridDataList[this.timeLineData].windD,
          parseInt(20 / this.map.map.getZoom()),
          this.gridDataList[this.timeLineData]
        );
        let ledcolorList = JSON.parse(JSON.stringify(legendColor["windmy"]));

        ledcolorList.map((item, index) => {
          //////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = this.optData / 400);
          }
        });
        ////console.log(ledcolorList);
        if (this.gridDataList[this.timeLineData] != undefined) {
          // if (this.tilePixelLayer) {
          //   this.map.map.removeLayer(this.tilePixelLayer);
          //   this.tilePixelLayer = null;
          // }

          this.chooseGridData = this.gridDataList[this.timeLineData];
          // this.addMakerToMap(this.gridDataList[this.timeLineData]);
          let dataList = this.gridDataList[this.timeLineData].windS.map(
            item => {
              return Number(item);
            }
          );

          // //////console.log(dataList);
          this.windspeedLayer = L.tilePixelLayer({
            newData: dataList,
            data: this.gridDataList[this.timeLineData],
            gradient: ledcolorList,
            clickEvt: function(e, gridValue) {
              // //console.log(e, gridValue);
              // t.filterTableData(e);
              let popup = L.popup({
                autoPanPaddingBottomRight: L.point(600, 0)
              })
                .setLatLng([e.latlng.lat, e.latlng.lng])
                .setContent(`<div>格点值:${gridValue}</div>`)
                .openOn(t.map.map);
            }
          });

          this.map.map.addLayer(this.windspeedLayer);
        }
      }
    },
    formatTooltip(val) {
      return val / 100;
    },
    openStrkHandell(data) {
      if (this.isOpenst == false) {
        let show = false;
        let t = this;
        this.isOpenstTimer = setInterval(() => {
          t.isOpenst = true;
          show = !show;
          t.showChooseArea(data, show);
        }, 1000);
      } else {
        clearInterval(this.isOpenstTimer);
        this.showChooseArea(data, false);
        this.isOpenst = false;
      }
    },
    showChooseArea(data, isshow) {
      let myusername = jsCookie.get("name");
      let areaList = data.area.split(",");
      let t = this;
      if (isshow) {
        if (myusername == "shimian") {
          this.wringLayer = L.geoJSON(shimian.features, {
            style: function() {
              return {
                color: t.waringIfoList.leaveType, //线颜色
                weight: 3, //线粗细
                opacity: 1, //透明度
                fillColor: t.waringIfoList.leaveType, //区域填充颜色
                fillOpacity: 0.5
              };
            },
            filter: function(geoJsonFeature) {
              return areaList.some(
                ele => ele === geoJsonFeature.properties.name
              );
            }
          }).addTo(this.map.map);
        } else if (myusername == "yingjing") {
          ////console.log("L.mask");
          L.mask(yingjing, { fillOpacity: 0.7 }).addTo(this.map.map);
          this.wringLayer = L.geoJSON(yingjing.features, {
            style: function() {
              return {
                color: t.waringIfoList.leaveType, //线颜色
                weight: 3, //线粗细
                opacity: 1, //透明度
                fillColor: t.waringIfoList.leaveType, //区域填充颜色
                fillOpacity: 0.5
              };
            },
            filter: function(geoJsonFeature) {
              return areaList.some(
                ele => ele === geoJsonFeature.properties.name
              );
            }
          }).addTo(this.map.map);
        }
      } else {
        if (this.wringLayer != null) {
          this.map.map.removeLayer(this.wringLayer);
          this.wringLayer = null;
        }
      }
    },
    showwaringDelInfo(e) {
      // //console.log(e);
      this.isShowwarningInfoBox = true;
      if (this.isOpenst == true) {
        clearInterval(this.isOpenstTimer);
        this.showChooseArea(this.waringIfoList, false);
        this.isOpenst = false;
      }
      this.waringIfoList = e;
      ////console.log(this.waringIfoList);
    },
    getWaterInfoData() {
      if (this.watherLayer != null) {
        this.map.map.removeLayer(this.watherLayer);
        this.watherLayer = null;
      }
      let markerListData = [];
      // this.$axios({
      //   method: "get",
      //   url: `
      // /api/SWDataservice/interface/v1/api?interfaceId=getRiver&adcode=510000&key=5ffd1a30-44f8-4298-a84e-8cd83430bdaf`
      // })
      let formData = new FormData();
      formData.append("adcode", `510000`);
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/data/getRiver`,
        data: formData
      })
        .then(res => {
          ////console.log(1111122);
          ////console.log(res);
          //  "dataList": [{
          //         "bsnm": "长江",//流域名称，string类型
          //         "name": "望江楼",//站点名称，string类型
          //         "rvnm": "府河",//江河名，string类型
          //         "type": "河道站",//站点类型，string类型
          //         "lon": "104.084121",//经度，string类型
          //         "lat": "30.644412",//纬度，string类型
          //         "datatime": "12-03 14:00",//观测数据时间，string类型
          //         "ql": 0,//流量，double类型，单位：立方米/秒
          //         "zl": 486.73,//水位，double类型，单位：米
          //         "wrz": 487,//警戒水位，double类型，单位：米
          //         "warning": "false" //是否超警戒，string类型
          //     }, {
          // //////console.log(res.data.dataList);
          var greenIcon = L.icon({
            iconUrl: waterPng, //icon阴影图片路径

            iconSize: [32, 32] // size of the icon
          });

          res.data.map(item => {
            //  .addTo(this.map.map);
            markerListData.push(
              L.marker([item.lat, item.lon], { icon: greenIcon })
                .bindPopup(
                  `
              <p>流域名称:${item.bsnm}</p>
              <p>站点名称:${item.name}</p>
              <p>江河名:${item.rvnm}</p>
              <p>站点类型:${item.type}</p>
            
              <p>观测数据时间:${item.datatime}</p>
              <p>流量:${item.ql}</p>
              <p>水位:${item.zl}</p>
              <p>警戒水位:${item.wrz}</p>
              <p>是否超警戒:${item.warning ? "超过" : "未超过"}</p>
              `
                )
                .openPopup()
            );
            // //////console.log(item);
          });
          this.watherLayer = L.layerGroup(markerListData).addTo(this.map.map);
          // this.waringList = res.data.dataList;
        })
        .catch(() => {});
    },
    arrChange(num, arr) {
      const newArr = [];
      while (arr.length > 0) {
        newArr.push(arr.splice(0, num));
      }
      return newArr;
    },
    addMakerToMap() {
      let data = this.chooseGridData;
      if (this.textmarkerLayer != null) {
        this.map.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      let xySum = 1;
      let dataList = [];
      if (this.checkList == "大风") {
        dataList = data.windS.map(item => {
          return Number(item);
        });
        xySum = 1;
      } else if (this.checkList == "雷达") {
        dataList = data.datas.map(item => {
          return Number(item);
        });
        xySum = 10;
      } else {
        dataList = data.datas.split(",").map(item => {
          return Number(item);
        });
        xySum = 5;
      }
      let NewDataList = this.arrChange(data.cols, dataList);

      // return;
      let index = 0;
      let xq = (data.right - data.left) / data.cols;
      let yq = (data.top - data.bottom) / data.rows;
      // //console.log(data.cols, data.rows);
      let makerList = [];
      for (let i = 0; i < data.rows; i += xySum) {
        for (let k = 0; k < data.cols; k += xySum) {
          let markerIcon = L.divIcon({
            html: `<div class="maerktext2" >${NewDataList[i][k].toFixed(
              1
            )}</div>`, //marker标注
            className: "my-div-icon",
            iconSize: [10, 10], //marker宽高
            iconAnchor: [10, 10] //文字标注相对位置
          });
          // index = index + 25;
          makerList.push(
            L.marker([data.top - yq * i, data.left + xq * k], {
              icon: markerIcon
            })
          );
        }
      }
      this.textmarkerLayer = L.layerGroup(makerList).addTo(this.map.map);
    },
    isshownumchange(e) {
      // //////console.log(e);
      if (e) {
        this.addMakerToMap();
      } else {
        if (this.textmarkerLayer != null) {
          this.map.map.removeLayer(this.textmarkerLayer);
          this.textmarkerLayer = null;
        }
      }
    },
    drawMakerTomap(mygetdata1, mygetdata2, zindex, data) {
      ////console.log(1111);
      ////console.log(data);
      ////console.log(mygetdata1);
      ////console.log(mygetdata2);
      if (this.tilePixelLayer != null) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }

      let myNewdata = JSON.parse(JSON.stringify(mygetdata1));
      let myNewdata2 = JSON.parse(JSON.stringify(mygetdata2));
      // let boxData = []
      ////console.log(myNewdata, myNewdata2);
      let ecBoxList = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList.push(newlist);
      }
      let ecBoxList2 = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata2.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList2.push(newlist);
      }
      let nx = (data.right - data.left) / data.cols;
      let ny = (data.top - data.bottom) / data.rows;
      let top = data.top;
      let left = data.left;
      let makerList = [];
      for (let y = 0; y < data.rows; y += zindex) {
        for (let x = 0; x < data.cols; x += zindex) {
          ////console.log(x, y);
          let windimg = wind1;
          if (ecBoxList[y][x] <= 0.2) {
            windimg = wind1;
          } else if (ecBoxList[y][x] <= 1.5) {
            windimg = wind2;
          } else if (ecBoxList[y][x] <= 3.3) {
            windimg = wind3;
          } else if (ecBoxList[y][x] <= 5.4) {
            windimg = wind4;
          } else if (ecBoxList[y][x] <= 7.9) {
            windimg = wind5;
          } else if (ecBoxList[y][x] <= 10.7) {
            windimg = wind6;
          } else if (ecBoxList[y][x] <= 13.8) {
            windimg = wind7;
          } else if (ecBoxList[y][x] <= 17.1) {
            windimg = wind8;
          } else if (ecBoxList[y][x] <= 20.7) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 24.4) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 28.4) {
            windimg = wind10;
          } else if (ecBoxList[y][x] <= 32.6) {
            windimg = wind11;
          } else if (ecBoxList[y][x] <= 36.9) {
            windimg = wind12;
          }
          ////console.log(windimg);
          let markerIcon = L.divIcon({
            html: `<div class="maerktext" style='-moz-transform:rotate(${ecBoxList2[y][x]}deg);
  -webkit-transform:rotate(${ecBoxList2[y][x]}deg);'><img src="${windimg}"></img></div>`, //marker标注
            className: "testBoxIcon",
            iconSize: [10, 10], //marker宽高
            iconAnchor: [10, 10] //文字标注相对位置
          });

          makerList.push(
            L.marker([top - ny * y, left + nx * x], {
              icon: markerIcon
            })
          );
        }
      }
      // ////console.log(makerList);
      this.tilePixelLayer = L.layerGroup(makerList).addTo(this.map.map);
      // });
    },
    getWaringData() {
      // let timeStr = new Date().getTime();
      // //////console.log();
      // let sinCode = md5(
      //   timeStr.toString().substring(0, 8) +
      //     "53A51DAC-8986-4A4B-B3BC-89585C897110"
      // );

      // this.$axios({
      //   method: "get",
      //   url: `https://int.scqx.net/?id=3019&sign=${sinCode.substring(0, 16)}`
      // }).then(res => {
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getYaanWarninfo`
      }).then(res => {
        ////console.log(111111);
        // //console.log(res.data);
        // if (res.data.cdata == undefined) {
        this.waringList = res.data;
        this.waringList2 = res.data;

        // this.waringList2 = [
        //   {
        //     headline: "石棉发布暴雨红色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "红色预警",
        //     text: "可能造成相关区域地质灾害（滑坡）",
        //     areanum: "242平方千米",
        //     area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
        //     tel: "182xxxxxxxx 王xx",
        //     leaveType: "red"
        //   },
        //   {
        //     headline: "石棉发布高温黄色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "黄色预警",
        //     text: "注意防晒",
        //     areanum: "242平方千米",
        //     area: "棉城街道,擦罗彝族乡,新棉镇",
        //     tel: "182xxxxxxxx",
        //     leaveType: "yellow"
        //   },
        //   {
        //     headline: "石棉发布大雾黄色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "黄色预警",
        //     text: "注意行车安全",
        //     areanum: "242平方千米",
        //     area: "宰羊乡,挖角彝族藏族乡,新棉镇",
        //     tel: "182xxxxxxxx",
        //     leaveType: "yellow"
        //   }
        // ];
        // } else {
        //   this.waringList = res.data.cdata;
        // }

        // this.weatherInfoData = res.data.cdata;
      });
    },
    getGridData(type) {
      // if (this.isplaying) {
      //   clearInterval(this.sldPlayTimeer);
      //   this.sldPlayTimeer = null;
      //   this.isplaying = !this.isplaying;
      //   // if (this.tilePixelLayer) {
      //   //   this.map.map.removeLayer(this.tilePixelLayer);
      //   //   this.tilePixelLayer = null;
      //   // }
      // }

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      let formData = new FormData();
      formData.append(
        "para",
        `{"dateTime":"${moment()
          .subtract(1, "h")
          .format("YYYY-MM-DD HH:00:00")}","areaCode":"${
          this.userareaCode
        }","element":"${type}","forcastTime":"null"}`
      );
      // formData.append(
      //   "para",
      //   `{"dateTime":"${moment()
      //     .subtract(1, "h")
      //     .format("YYYY-MM-DD HH:00:00")}","areaCode":"${
      //     this.userareaCode
      //   }","element":"${type}","forcastTime":"null"}`
      // );
      // formData.append(
      //   "para",
      //   `{"dateTime":"2024-04-17 08:00:00","areaCode":"511824","element":"rain","forcastTime":"null"}`
      // );
      // formData.append("apiName", `grid,getForcastHour`);
      // formData.append("element", type);
      // formData.append("forcastTime", null);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `http://120.79.183.250:3099/grid/getForcastHour2`,
        // url: `http://120.79.183.250:3099/SWDataservice/interface/customApi`,
        // url: `http:///SWDataservice/interface/customApi`,
        data: formData
      })
        .then(res => {
          // //console.log(JSON.parse(unzip(res.data.datas)).grid);
          let unzipList = JSON.parse(unzip(res.data.datas)).grid;
          this.gridDataList = [];
          if (type != "wind") {
            this.ledgonList = legendColor[type];
            ////console.log(this.ledgonList);

            this.isShowWindLayer = false;
            let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));

            ledcolorList.map((item, index) => {
              //////console.log(index);
              if (index == 0) {
                return (item[1][3] = 0);
              } else {
                return (item[1][3] = this.optData / 100);
              }
            });
            // //console.log(ledcolorList);
            this.chooseGridData = unzipList[this.timeLineData];
            // //console.log(this.chooseGridData.datas);
            let dataList = unzipList[this.timeLineData].datas
              .split(", ")
              .map(item => {
                return Number(item);
              });
            // //console.log(dataList);

            this.gridDataList = unzipList;
            let t = this;
            this.tilePixelLayer = L.tilePixelLayer({
              newData: dataList,
              data: unzipList[this.timeLineData],
              gradient: ledcolorList,
              clickEvt: function(e, gridValue) {
                console.log(e, gridValue);
                // t.filterTableData(e);
                let popup = L.popup({
                  autoPanPaddingBottomRight: L.point(600, 0)
                })
                  .setLatLng([e.latlng.lat, e.latlng.lng])
                  .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
                  .openOn(t.map.map);
              }
            });
            this.map.map.addLayer(this.tilePixelLayer);
            // //console.log(this.tilePixelLayer);
          } else {
            this.ledgonList = legendColor["windmy"];
            let ledcolorList = JSON.parse(
              JSON.stringify(legendColor["windmy"])
            );
            ledcolorList.map((item, index) => {
              //////console.log(index);
              if (index == 0) {
                return (item[1][3] = 0);
              } else {
                return (item[1][3] = this.optData / 100);
              }
            });
            let dataList = unzipList[this.timeLineData].windS.map(item => {
              return Number(item);
            });
            this.windspeedLayer = L.tilePixelLayer({
              newData: dataList,
              data: unzipList[this.timeLineData],
              gradient: ledcolorList,
              clickEvt: function(e, gridValue) {
                // //console.log(e, gridValue);
                // t.filterTableData(e);
                let popup = L.popup({
                  autoPanPaddingBottomRight: L.point(600, 0)
                })
                  .setLatLng([e.latlng.lat, e.latlng.lng])
                  .setContent(`<div>格点值:${gridValue}</div>`)
                  .openOn(t.map.map);
              }
            });
            this.map.map.addLayer(this.windspeedLayer);
            this.isShowWindLayer = true;
            ////console.log("wind");
            ////console.log(res.data.grid);
            let firstData = unzipList[this.timeLineData];
            this.chooseGridData = unzipList[this.timeLineData];
            ////console.log(firstData.windS);
            this.gridDataList = unzipList;
            this.drawMakerTomap(
              firstData.windS,
              firstData.windD,
              parseInt(20 / this.map.map.getZoom()),
              firstData
            );
          }

          this.getlineMarker(res.data.result);
          loading.close();
          // this.waringList = res.data.dataList;
        })
        .catch(() => {
          loading.close();
        });
    },
    getNewimgData() {},
    async getCloundData() {
      let myNewUrl = "";

      var myDate2 = new Date();
      let startTime = moment()
        .subtract(8, "h")
        .format("YYYYMMDDHH0000");
      for (let i = 0; i < 20; i++) {
        // if (i == 522) {
        //   break;
        // }
        console.log(
          moment(startTime, "YYYYMMDDHH0000000")
            .subtract(i * 15, "m")
            .format("YYYYMMDDHHmm00000")
        );
        let url = `http://image.nmc.cn/product/${myDate2.getFullYear()}/${moment().format(
          "MM"
        )}/${moment(startTime, "YYYYMMDDHH00")
          .subtract(i * 15, "m")
          .format("DD")}/WXBL/SEVP_NSMC_WXBL_FY4B_ETCC_ACHN_LNO_PY_${moment(
          startTime,
          "YYYYMMDDHH00"
        )
          .subtract(i * 15, "m")
          .format("YYYYMMDDHHmm")}00000.JPG`;
        // if()
        // console.log(url);
        let ishaveData = false;
        await this.isHasImg(url).then(res => {
          if (res) {
            console.log(res);
            myNewUrl = url;
            ishaveData = true;
          }
        });
        if (ishaveData) {
          break;
        }
        // alert(i);
        // document.write(i);
      }
      console.log(myNewUrl);
      // console.log(i);
      // return;
      // var myDate2 = new Date();
      // let url = `http://image.nmc.cn/product/${myDate2.getFullYear()}/${moment().format(
      //   "MM"
      // )}/${moment().get(
      //   "date"
      // )}/WXBL/SEVP_NSMC_WXBL_FY4B_ETCC_ACHN_LNO_PY_${moment()
      //   .subtract(7, "h")
      //   .format("YYYYMMDDHH0000000")}.JPG`;
      // // console.log(url);
      // if (this.isHasImg(url) == false) {
      //   url = `http://image.nmc.cn/product/${myDate2.getFullYear()}/${moment().format(
      //     "MM"
      //   )}/${moment().get(
      //     "date"
      //   )}/WXBL/SEVP_NSMC_WXBL_FY4B_ETCC_ACHN_LNO_PY_${moment()
      //     .subtract(8, "h")
      //     .format("YYYYMMDDHH0000000")}.JPG`;
      // }
      let imageBounds = [
        [2, 60.0],
        [53, 139.5]
      ];
      // console.log(this.isHasImg(url));

      // 将图片作为自定义图层加载到地图上（类似于Marker）
      this.imgLayer = L.imageOverlay(myNewUrl, imageBounds, {
        opacity: 1,
        zIndex: 999
      }).addTo(this.map.map);
    },
    isHasImg(imgurl2) {
      return new Promise(function(resolve, reject) {
        var ImgObj = new Image(); //判断图片是否存在
        ImgObj.src = imgurl2;
        ImgObj.onload = function(res) {
          if (this.complete == true) {
            resolve(true); //正常返回true
          }
        };
        ImgObj.onerror = function(err) {
          resolve(false); //  图片异常 就返回false
        };
      });
    },

    getCloundData2() {
      let hash = md5("value");
      //////console.log(hash);
      let timeStr = new Date().getTime();
      //////console.log();
      let sinCode = md5(
        timeStr.toString().substring(0, 8) +
          "53A51DAC-8986-4A4B-B3BC-89585C897110"
      );
      //////console.log(sinCode.substring(0, 16));

      this.$axios({
        method: "get",
        url: `https://int.scqx.net/?id=3038&sign=${sinCode.substring(0, 16)}`
      }).then(res => {
        if (res.data.cdata == undefined) {
          let imageBounds = [
            [2, 60.0],
            [53, 139.5]
          ];
          // 将图片作为自定义图层加载到地图上（类似于Marker）
          this.imgLayer = L.imageOverlay(
            "http://file.scqx.net/file/general/sat/20240304164500.jpg",
            imageBounds,
            { opacity: 1, zIndex: 999 }
          ).addTo(this.map.map);
        } else {
          let imageBounds = [
            [2, 60.0],
            [53, 139.5]
          ];
          // 将图片作为自定义图层加载到地图上（类似于Marker）
          this.imgLayer = L.imageOverlay(res.data.cdata[0].url, imageBounds, {
            opacity: 1,
            zIndex: 999
          }).addTo(this.map.map);
        }

        // ////console.log(res.data.cdata[0].url);
        // this.isShowClound = true;
        // this.cloundImg = res.data.cdata;
      });
    },
    showPlaceStationToMap() {
      if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      let formData = new FormData();
      formData.append(
        "para",
        `{"deviceId":"null","deviceName":"null","deviceCode":"null","deviceTypeName":"null","areaCode":"null","Province":"null","City":"null","Country":"null","typeCode":"null","typeName":"${this.checkList}"}`
      );
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/device/getDeformationStation`,
        data: formData
      }).then(res => {
        // //console.log(res);

        let moveIcon = L.icon({
          iconUrl: movePng, //icon阴影图片路径

          iconSize: [32, 29] // size of the icon
        });
        if (this.checkList == "GNSS连续站" || this.checkList == "GNSS区域站") {
          moveIcon = L.icon({
            iconUrl: movePng2, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        } else if (
          this.checkList == "跨断层水准测距综合场地" ||
          this.checkList == "跨断层水准场地"
        ) {
          moveIcon = L.icon({
            iconUrl: movePng3, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        } else if (
          this.checkList == "重力" ||
          this.checkList == "流动地磁矢量" ||
          this.checkList == "流动地磁总强度" ||
          this.checkList == "蠕变动态观测台"
        ) {
          moveIcon = L.icon({
            iconUrl: movePng4, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        }
        let markerList = [];
        res.data.map(item => {
          markerList.push(
            L.marker([item.Lat, item.Lon], { icon: moveIcon })
              .bindPopup(
                `
              <p>城市:${item.City}</p>
              <p>区县:${item.Country}</p>
              <p>站点:${item.deviceName}</p>
              <p>站号:${item.deviceId}</p>
             
              <p>类型:${item.deviceTypeName}</p>
              `
              )
              .openPopup()
          );
        });
        this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
      });
    },
    showTypeChange(e) {
       if (this.rainLayer != null) {
        this.rainLayer.clearLayers();
        // this.rainLayer=null
      }
       if (this.myimgLaryer != null) {
        this.map.map.removeLayer(this.myimgLaryer);
        this.myimgLaryer = null;
      }
      if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      this.isShowWindLayer = false;
      if (this.lightningLayer != null) {
        this.map.map.removeLayer(this.lightningLayer);
        this.lightningLayer = null;
      }
      // if (this.movePlaceLayer != null) {
      //   this.map.map.removeLayer(this.movePlaceLayer);
      //   this.movePlaceLayer = null;
      // }
      if (this.isplaying) {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
        this.isplaying = !this.isplaying;
      }
      if (this.imgLayer != null) {
        this.map.map.removeLayer(this.imgLayer);
        this.imgLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.checkList2 == "地质") {
        if (e == "GNSS自建站") {
          this.getwaringListplaceData();
        } else {
          this.showPlaceStationToMap();
        }
      } else if (this.checkList2 == "气象") {
        if (e == "雨量") {
          this.getGridData("rain");
        } else if (e == "温度") {
          this.getGridData("tem");
        } else if (e == "大风") {
          this.isShowWindLayer = true;
          this.getGridData("wind");
          // this.isSHowtimeled = false;
          // this.isshowmyoptbtn = false;
        } else if (e == "闪电") {
          this.getLightningData();
        } else if (e == "云图") {
          this.getCloundData();
        } else if (e == "雷达") {
          this.getRadarData();
        }else if (e == "全国降水") {
          // console.log("全国降水");
          this.getWaeatherlayer('LeastRain')
        }else if (e == "全国雷达") {
        //  console.log("全国雷达");
        this.getWaeatherlayer('LastRadar')
        }
      }
      // else if (this.checkList2 == "重点关注") {
      //   this.getDangerDataList();
      // }
    },
    getRadarData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }
      let formData = new FormData();

      formData.append(
        "para",
        `{"dateTime":"null","areaCode":"${this.userareaCode}","element":"rain","forcastTime":"null"}`
      );
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/grid/getRadarForcastHour2`,
        data: formData
      })
        .then(res => {
          let unzipList = JSON.parse(unzip(res.data.datas)).grid;
          ////console.log(res.data.grid);
          this.ledgonList = legendColor[type];
          ////console.log(this.ledgonList);

          this.isShowWindLayer = false;
          let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));

          ledcolorList.map((item, index) => {
            //////console.log(index);
            if (index == 0) {
              return (item[1][3] = 0);
            } else {
              return (item[1][3] = this.optData / 100);
            }
          });

          this.chooseGridData = unzipList[this.timeLineData];
          let dataList = unzipList[this.timeLineData].datas.map(item => {
            return Number(item);
          });
          // //console.log(dataList);
          let t = this;
          this.gridDataList = unzipList;
          this.tilePixelLayer = L.tilePixelLayer({
            newData: dataList,
            data: unzipList[this.timeLineData],
            gradient: ledcolorList,
            clickEvt: function(e, gridValue) {
              // //console.log(e, gridValue);
              // t.filterTableData(e);
              let popup = L.popup({
                autoPanPaddingBottomRight: L.point(600, 0)
              })
                .setLatLng([e.latlng.lat, e.latlng.lng])
                .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
                .openOn(t.map.map);
            }
          });
          this.map.map.addLayer(this.tilePixelLayer);
          loading.close();
          // this.waringList = res.data.cdata;
          // this.weatherInfoData = res.data.cdata;
        })
        .catch(() => {
          loading.close();
        });
    },
    getLightningData() {
      var hash = md5("value");
      //////console.log(hash);
      let timeStr = new Date().getTime();
      //////console.log();
      let sinCode = md5(
        timeStr.toString().substring(0, 8) +
          "53A51DAC-8986-4A4B-B3BC-89585C897110"
      );
      //////console.log(sinCode.substring(0, 16));
      let markerList = [];
      this.$axios({
        method: "get",
        url: `https://int.scqx.net/?id=3036&sign=${sinCode.substring(0, 16)}`
      }).then(res => {
        ////console.log(res.data.cdata);
        if (res.data.status != "105") {
          this.lightningData = res.data.cdata;
        }
        this.lightningData.map(item => {
          let myIcon = L.icon({
            iconUrl: require("../assets/lintinfg.png"),
            iconSize: [30, 30],

            popupAnchor: [-15, -15]
          });

          markerList.push(L.marker([item.lat, item.lng], { icon: myIcon }));
        });
        this.lightningLayer = L.layerGroup(markerList).addTo(this.map.map);
        // this.weatherInfoData = res.data.cdata;
      });
    },
    extendCheckChange(e) {
      console.log(2112212121);
      console.log(e.indexOf("水系") != -1);
      if (e.indexOf("水系") != -1) {
        // if (this.isSHowWarter) {
        this.waterLayer = L.geoJSON(WaterJson.features).addTo(this.map.map);
        // } else {
        //   if (this.waterLayer != null) {
        //     this.map.map.removeLayer(this.waterLayer);
        //     this.waterLayer = null;
        //   }
        // }
      } else {
        if (this.waterLayer != null) {
          this.map.map.removeLayer(this.waterLayer);
          this.waterLayer = null;
        }
      }
      if (e.indexOf("地震带") != -1) {
        // if (this.isSHowWarter) {
        this.DZlineLayer = L.geoJSON(sicdiz.features, {
          color: "red"
        }).addTo(this.map.map);
        // } else {
        //   if (this.waterLayer != null) {
        //     this.map.map.removeLayer(this.waterLayer);
        //     this.waterLayer = null;
        //   }
        // }
      } else {
        if (this.DZlineLayer != null) {
          this.map.map.removeLayer(this.DZlineLayer);
          this.DZlineLayer = null;
        }
      }
      if (e.indexOf("路网") != -1) {
        // if (this.isShowRold) {
        this.roldLayer = L.geoJSON(roldJson.features, {
          style: {
            color: "#fff200", //线颜色
            weight: 1, //线粗细
            opacity: 1, //透明度
            fillColor: "#fff200", //区域填充颜色
            fillOpacity: 0 //区域填充颜色的透明
          }
        }).addTo(this.map.map);
        // } else {
        //   if (this.roldLayer != null) {
        //     this.map.map.removeLayer(this.roldLayer);
        //     this.roldLayer = null;
        //   }
        // }
      } else {
        if (this.roldLayer != null) {
          this.map.map.removeLayer(this.roldLayer);
          this.roldLayer = null;
        }
      }
      if (e.indexOf("居民区") != -1) {
        // if (this.isShowHouse) {
        this.peoLayer = L.geoJSON(peoJson.features, {
          style: {
            color: "red", //线颜色
            weight: 1, //线粗细
            opacity: 1, //透明度
            fillColor: "red", //区域填充颜色
            fillOpacity: 0 //区域填充颜色的透明
          }
        }).addTo(this.map.map);
        // } else {
        //   if (this.peoLayer != null) {
        //     this.map.map.removeLayer(this.peoLayer);
        //     this.peoLayer = null;
        //   }
        // }
      } else {
        if (this.peoLayer != null) {
          this.map.map.removeLayer(this.peoLayer);
          this.peoLayer = null;
        }
      }
      if (e.indexOf("水位") != -1) {
        // if (this.isShowwater) {
        this.getWaterInfoData();
        // } else {
        //   if (this.watherLayer != null) {
        //     this.map.map.removeLayer(this.watherLayer);
        //     this.watherLayer = null;
        //   }
        // }
      } else {
        if (this.watherLayer != null) {
          this.map.map.removeLayer(this.watherLayer);
          this.watherLayer = null;
        }
      }
    },
    getweatherData() {
      //console.log(this.stationCenter);
      this.$axios({
        method: "post",
        url: `
        http://120.79.183.250:3099/data/getActualElementsByPosition?Longitude=${this.stationCenter[0]}&Latitude=${this.stationCenter[1]}`,
        // url: `
        // /api/SWDataservice/interface/v1/api?interfaceId=getActualElementsByPosition&Longitude=103.009&Latitude=29.999`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        ////console.log(111);
        ////console.log(res.data);
        // this.weatherdata = res.data[0];
        // this.waringList = res.data.dataList;
      });
    },
    getrgb(data) {
      //// //////console.log(data);
      //// //////console.log(`rgb(${data[1][0]},${data[1][1]},${data[1][2]})`);
      return `rgb(${data[1][0]},${data[1][1]},${data[1][2]})`;
    },
    palyvideo(url) {
      this.videoPlayer = Videojs(document.querySelector("#mmiid"), {
        autoplay: "muted", //自动播放
        controls: true, //用户可以与之交互的控件
        loop: true, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        aspectRatio: "16:9", //显示比率
        fullscreen: {
          options: { navigationUI: "hide" }
        },
        techOrder: ["html5", "flvjs"], // 兼容顺序
        html5: {
          hls: {
            withCredentials: true
          }
        },
        sources: [
          {
            src: url,
            type: "application/x-mpegURL"
          }
        ]
      });
    },
    getWaeatherlayer(e) {
      if (this.myimgLaryer != null) {
        this.map.map.removeLayer(this.myimgLaryer);
        this.myimgLaryer = null;
      }
      if (this.rainLayer != null) {
        this.rainLayer.clearLayers();
        // this.rainLayer=null
      }

      this.choseShowlayer = e;
      let url = `https://typhoon.slt.zj.gov.cn/Api/LeastCloud/?type=3`;
      if (e == "LeastCloud") {
        url = `https://typhoon.slt.zj.gov.cn/Api/LeastCloud/?type=3`;
      } else if (e == "LastRadar") {
        url = "https://typhoon.slt.zj.gov.cn/Api/LastRadar";
      } else {
        this.getRainType();
        return;
      }
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: url
      }).then(res => {
        let imageBounds = [
          ["-2", "95"],
          ["43", "160"]
        ];
        let imageUrl = "";
        // console.log(res.data.cloud3h);
        if (e == "LeastCloud") {
          imageUrl = res.data.cloud3h;
        }else if(e=='LastRadar'){
          imageUrl = res.data.radar0_0;
           imageBounds = [
            ["11.39716187", "72.502355"],
            ["54.563269", "138.09567"]
          ];
        } else {
          imageUrl = res.data.radar0_0;
          imageBounds = [
            ["3.39716187", "73.502355"],
            ["54.563269", "135.09567"]
          ];
        }

        let imgdata = res.data;
        // console.log();

        //  if()
        //  let imageBounds = [[imgdata.minLat, imgdata.minLng], [imgdata.maxLat, imgdata.maxLng]];
        this.myimgLaryer = L.imageOverlay(imageUrl, imageBounds).addTo(
          this.map.map
        );
      });
    },
        getRainType() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://typhoon.slt.zj.gov.cn/Api/LeastRain/24`
      }).then(res => {
        console.log(JSON.parse(res.data.contours));
        let mydata = JSON.parse(res.data.contours);
        mydata.map(item => {
          let polygon = L.polygon(item.latAndLong, {
            color: `rgb(${item.color})`,
            opacity: 0,
            fillOpacity: 0.5,
            pane: "labels"
          });

          this.rainLayer.addLayer(polygon);
          // this.map.map.fitBounds(polygon.getBounds());
        });

        // this.rainLayer.setZIndex(1)
      });
    },
    checkList2change(e) {
      if (this.watherLayer != null) {
        this.map.map.removeLayer(this.watherLayer);
        this.watherLayer = null;
      }
      // if (this.movePlaceLayer != null) {
      //   this.map.map.removeLayer(this.movePlaceLayer);
      //   this.movePlaceLayer = null;
      // }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      if (e == "气象") {
        this.checkListdata = ["雨量", "温度", "云图", "雷达",'全国降水','全国雷达'];
        this.checkList = "雨量";
        this.showTypeChange("雨量");
      } else if (e == "地质") {
        this.getwaringListplaceData();
        // this.checkListdata = ["地灾", "位移", "沉降"];
        this.checkListdata = [
          "GNSS自建站",
          "跨断层水准测距综合场地",
          "跨断层水准场地",
          "GNSS区域站",
          "GNSS连续站",
          "重力",
          "流动地磁矢量",
          "流动地磁总强度",
          "蠕变动态观测台"
        ];
        this.checkList = "GNSS自建站";
      }
      // else if (e == "重点关注") {

      //   this.checkListdata = ["地灾隐患点", "重点观测点"];
      //   this.checkList = "地灾隐患点";
      // this.getDangerDataList();
      // }
      // else {
      //   this.getWaterInfoData();
      // }
    },
    getwaringListplaceData() {
      if (this.watherLayer != null) {
        this.map.map.removeLayer(this.watherLayer);
        this.watherLayer = null;
      }
      let formData = new FormData();

      formData.append(
        "para",
        `{"startTime":"null","endTime":"null","deviceId":"null","deviceType":"L1_GP_1","xStart":"null","xEnd":"null","yStart":"null","yEnd":"null","zStart":"null","zEnd":"null"}`
      );

      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/device/getGnssData`,
        data: formData
      }).then(res => {
        ////console.log(res.data);
        let moveIcon = L.icon({
          iconUrl: movePng, //icon阴影图片路径

          iconSize: [25, 25] // size of the icon
        });
        // movePlaceLayer
        let markerList = [];
        res.data.map(item => {
          markerList.push(
            L.marker([item.lat, item.lon], { icon: moveIcon })
              .bindPopup(
                `
              <p>城市:${item.city}</p>
              <p>区县:${item.country}</p>
              <p>时间:${item.dateTime}</p>
              <p>站点:${item.deviceName}</p>
            
              <p>类型:${item.deviceTypeName}</p>
              <p>x轴位移:${item.xOffset}</p>
              <p>y轴位移:${item.yOffset}</p>
              <p>z轴位移:${item.zOffset}</p>
         
              `
              )
              .openPopup()
          );
        });
        this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
        // this.waringListplace = res.data;
        // ////console.log(res.data.datas[0]);
      });
    },
    palyHander() {
      this.isplaying = !this.isplaying;
      if (this.isplaying) {
        this.isshownum = false;
        this.isshownumchange(this.isshownum);
        this.sldPlayTimeer = setInterval(() => {
          if (this.timeLineData == 119) {
            this.timeLineData = 0;
          } else {
            this.timeLineData = this.timeLineData + 1;
          }

          this.changeMapGrid();
        }, 1000);
      } else {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
      }
    },
    changeMapGrid() {
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }
      if (type != "wind") {
        let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));
        ledcolorList.map((item, index) => {
          //////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = this.optData / 400);
          }
        });
        if (this.gridDataList[this.timeLineData] != undefined) {
          // if (this.tilePixelLayer) {
          //   this.map.map.removeLayer(this.tilePixelLayer);
          //   this.tilePixelLayer = null;
          // }

          this.chooseGridData = this.gridDataList[this.timeLineData];
          // this.addMakerToMap(this.gridDataList[this.timeLineData]);
          let dataList = [];
          if (type == "radar") {
            dataList = this.gridDataList[this.timeLineData].datas.map(item => {
              return Number(item);
            });
          } else {
            dataList = this.gridDataList[this.timeLineData].datas
              .split(",")
              .map(item => {
                return Number(item);
              });
          }
          ////console.log(dataList);
          let oldTitle = this.tilePixelLayer;
          // //////console.log(dataList);
          this.tilePixelLayer = L.tilePixelLayer({
            newData: dataList,
            data: this.gridDataList[this.timeLineData],
            gradient: ledcolorList,
            clickEvt: function(e, gridValue) {
              // //console.log(e, gridValue);
              // t.filterTableData(e);
              let popup = L.popup({
                autoPanPaddingBottomRight: L.point(600, 0)
              })
                .setLatLng([e.latlng.lat, e.latlng.lng])
                .setContent(`<div>格点值:${gridValue}</div>`)
                .openOn(t.map.map);
            }
          });
          // this.map.map.on("layeradd", () => {
          //  // //console.log("layeradd");
          //   this.map.map.removeLayer(oldTitle);
          // });
          this.map.map.addLayer(this.tilePixelLayer);
          setTimeout(() => {
            this.map.map.removeLayer(oldTitle);
          }, 1000);
        }
      } else {
        if (this.tilePixelLayer) {
          this.map.map.removeLayer(this.tilePixelLayer);
          this.tilePixelLayer = null;
        }
        if (this.gridDataList[this.timeLineData] != undefined) {
          this.drawMakerTomap(
            this.gridDataList[this.timeLineData].windS,
            this.gridDataList[this.timeLineData].windD,
            parseInt(20 / this.map.map.getZoom()),
            this.gridDataList[this.timeLineData]
          );
          let ledcolorList = JSON.parse(JSON.stringify(legendColor["windmy"]));

          ledcolorList.map((item, index) => {
            //////console.log(index);
            if (index == 0) {
              return (item[1][3] = 0);
            } else {
              return (item[1][3] = this.optData / 400);
            }
          });
          if (this.gridDataList[this.timeLineData] != undefined) {
            // if (this.tilePixelLayer) {
            //   this.map.map.removeLayer(this.tilePixelLayer);
            //   this.tilePixelLayer = null;
            // }

            this.chooseGridData = this.gridDataList[this.timeLineData];
            // this.addMakerToMap(this.gridDataList[this.timeLineData]);
            let dataList = this.gridDataList[this.timeLineData].windS.map(
              item => {
                return Number(item);
              }
            );
            ////console.log(dataList);
            let oldTitle = this.windspeedLayer;
            // //////console.log(dataList);
            this.windspeedLayer = L.tilePixelLayer({
              newData: dataList,
              data: this.gridDataList[this.timeLineData],
              gradient: ledcolorList,
              clickEvt: function(e, gridValue) {
                // //console.log(e, gridValue);
                // t.filterTableData(e);
                let popup = L.popup({
                  autoPanPaddingBottomRight: L.point(600, 0)
                })
                  .setLatLng([e.latlng.lat, e.latlng.lng])
                  .setContent(`<div>格点值:${gridValue}</div>`)
                  .openOn(t.map.map);
              }
            });

            this.map.map.addLayer(this.windspeedLayer);
            setTimeout(() => {
              this.map.map.removeLayer(oldTitle);
            }, 1000);
          }
        }
      }

      // this.isshownumchange(this.isshownum);
    },
    getlineMarker() {
      let newdate = moment().format("HH:00");
      // //////console.log(newdate);
      let marker = {};
      for (let i = 0; i < 120; i++) {
        //// //////console.log(i);
        if (i % 8 == 0) {
          marker[i] = {
            style: {
              color: "white"
            },
            label: moment(newdate, "HH:mm")
              .add(i, "m")
              .format("HH:mm")
          };
        }
      }
      // //////console.log(marker);
      this.marks = marker;
    }
  }
};
</script>

<style lang="scss"  scoped>
@function px2vw($px) {
  @return $px * 100vw / 1920;
}
.watchBody {
  height: 100vh;
  width: 100vw;
  background-color: aqua;
  overflow: hidden;
}
.maerktext {
  font-size: px2vw(12);
  color: white;
}
.maerktext2 {
  font-size: px2vw(12);
  color: rgb(255, 255, 255);
  background-color: #1e4e4e83;
  // padding: 2px;
  width: 15px;
  text-align: center;
}
.leftConBox {
  position: absolute;
  left: 0;
  z-index: 999;
  pointer-events: none;
  width: px2vw(650);
  height: px2vw(1080);
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0) 0%,
    rgba(17, 32, 37, 0.9) 69.84%
  );
}
.rightConBox {
  position: absolute;
  right: 0;
  z-index: 999;
  pointer-events: none;
  width: px2vw(650);
  height: px2vw(1080);
  background: linear-gradient(
    90deg,
    rgba(17, 32, 37, 0) 0%,
    rgba(17, 32, 37, 0.9) 69.84%
  );
}
.weatherBox {
  position: absolute;
  top: px2vw(80);
  left: px2vw(30);
  pointer-events: auto;
  // background-color: aqua;
  // width: 400px;
  // width: 4rem;
  width: px2vw(400);
  height: px2vw(300);
  /* border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(270deg, rgba(34, 67, 77, 0.6) 0%, rgba(29, 62, 70, 1) 100%);
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(270deg, rgba(17, 32, 37, 0.1) 0%, rgba(22, 39, 45, 0.5) 100%); */
}
.weatherTitle {
  width: px2vw(400);
  height: px2vw(46);
  background-image: url("../assets/Group_48097197.png");
  /* background-color: aqua; */
  background-size: cover;
}
.downLoadBtn {
  height: 30px;
  width: 80px;
  background-color: #32dcfe;
  position: absolute;
  right: 0px;
  top: 20px;
  // border: 1px solid rgb(74, 107, 108);
  text-align: center;
  line-height: 30px;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
}
.weatherTitText {
  // width: px2vw(78);
  height: px2vw(22);
  position: relative;
  top: px2vw(18);
  left: px2vw(18);
  text-align: left;
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(18);
  line-height: 120.000005%;
  letter-spacing: 10%;
}
.weatherMainBox {
  width: px2vw(400);
  height: px2vw(260);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-content: space-around;
  overflow: hidden;
}

.weatherMainBoxItem {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436.png");
  background-size: cover;
}
.weatherMainBoxItem2 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_1.png");
  background-size: cover;
}
.weatherMainBoxItem3 {
  width: px2vw(184);
  height: px2vw(50);
  background-image: url("../assets/Group_48097436_2.png");
  background-size: 100% 100%;
  display: flex;
  // justify-content: space-around;
}
.weatherMainBoxItem4 {
  width: px2vw(184);
  height: px2vw(50);
  background-image: url("../assets/Group_48097436_3.png");
  background-size: 100% 100%;
  display: flex;
}
.weatherMainBoxItem5 {
  width: px2vw(184);
  height: px2vw(50);
  background-image: url("../assets/Group_48097436_4.png");
  background-size: 100% 100%;
  display: flex;
}
.weatherMainBoxItem6 {
  width: px2vw(184);
  height: px2vw(50);
  background-image: url("../assets/Group_48097436_5.png");
  background-size: 100% 100%;
  display: flex;
}
.weatherMainBoxItemIconBox {
  width: px2vw(68);
  height: 100%;
  // background-color: red;
}
.weatherMainBoxItemtextBox {
  width: px2vw(116);
  height: 100%;
  // background-color: red;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.weatherText {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  line-height: 120.000005%;
  letter-spacing: 10%;
  width: px2vw(28);
  line-height: px2vw(25);
}
.weatherinfotext {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk JinBuTi";
  font-weight: 400;
  font-size: px2vw(22);
  line-height: 120.000005%;
  letter-spacing: 10%;
  width: px2vw(52);
  line-height: px2vw(25);
}
.weatherinfotext2 {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk JinBuTi";
  font-weight: 400;
  font-size: px2vw(14);
  line-height: 120.000005%;
  letter-spacing: 10%;
  width: px2vw(52);
  line-height: px2vw(25);
}
.videoBox {
  position: absolute;
  top: px2vw(730);
  left: px2vw(30);
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(350);
  pointer-events: auto;
}
.warningInfoText {
  width: px2vw(720);
  height: px2vw(36);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  position: absolute;
  top: px2vw(100);
  left: px2vw(600);
  z-index: 999;
  // transform: translateX(-px2vw(260));
  // text-align: center;
  line-height: px2vw(36);
  color: rgb(255, 255, 255);
  /* background: linear-gradient(
    180deg,
    rgba(255, 238, 181, 1) 20.38%,
    rgba(255, 255, 255, 1) 81.16%
  ); */
  /* -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent; */
  font-family: Microsoft YaHei UI;
  /* font-weight: bold; */
  font-size: px2vw(15);
  font-weight: 700;
  overflow: hidden;
  // padding: 0 0 0 px2vw(100);
  /* color: #e7e2c0; */
  /* letter-spacing: 10%; */
  background-image: url("../assets/Group_1321314686.png");
  background-size: cover;
}
.warningInfoTextItem {
  margin-left: px2vw(100);
  // background-color: red;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
}
@keyframes around222 {
  from {
    left: 100%;
  }

  to {
    /* left: calc(0px - var(--textWidth--) - 10px); */
    left: -100%;
  }
}
// .warningInfoTextItem span {
//   position: absolute;
//   top: 0;
//   left: 0;
// }
.warningInfoTextItem span {
  /* width: 80%; */
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  margin: 0 px2vw(10);
  white-space: nowrap;
  animation: around222 10s linear infinite;
}
.videoMainBox {
  width: px2vw(400);
  height: px2vw(214);
  border: 1px solid rgba(48, 92, 108, 1);
  box-sizing: border-box;
}
/* .videoListbox {
  height: 80px;
  width: 95%;

  display: flex;
  justify-content: space-around;
  align-content: space-around;
  flex-wrap: wrap;
} */
.myviewSelect {
  height: px2vw(30) !important;
}
.videoListbox {
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(50);
  right: px2vw(10);
}
.videoListboxItem {
  width: px2vw(116);
  height: px2vw(30);
  background-color: aqua;
  background-image: url("../assets/85412.png");
  color: rgba(102, 182, 200, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  text-align: center;
  line-height: px2vw(30);
  background-size: cover;
}
.msgBox {
  position: absolute;
  top: px2vw(720);
  left: px2vw(30);
  pointer-events: auto;
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(180);
  /* border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(270deg, rgba(34, 67, 77, 0.6) 0%, rgba(29, 62, 70, 1) 100%);
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(270deg, rgba(17, 32, 37, 0.1) 0%, rgba(22, 39, 45, 0.5) 100%); */
}
.msgMainBox {
  width: px2vw(400);
  height: px2vw(126);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(14);
}
.msgMainBoxItem {
  width: px2vw(372);
  height: px2vw(26);
  background: rgba(0, 170, 255, 0.08);
  display: flex;
  align-items: center;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  padding: px2vw(5);
  margin-top: px2vw(5);
}
.msgMainBoxItem2 {
  position: absolute;
  top: px2vw(900);
  left: px2vw(30);
  /* background: rgba(0, 170, 255, 0.08); */
  display: flex;
  align-items: center;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  padding: px2vw(5);
  margin-top: px2vw(5);
  // display: flex;
  // justify-content: flex-end;
}
.warningBoxf {
  position: absolute;
  top: px2vw(400);
  /* left: 1490px; */
  left: px2vw(30);
  pointer-events: auto;
  /* background-color: aqua; */
  width: px2vw(400);
  // height: px2vw(300);
  // z-index: 999;
}
.warningBoxf22 {
  position: absolute;
  top: px2vw(80);
  /* left: 1490px; */
  right: px2vw(30);
  pointer-events: auto;
  /* background-color: aqua; */
  // background-color: red;
  width: px2vw(400);
  height: px2vw(150);
}
.warningMainBox {
  width: px2vw(400);
  height: px2vw(260);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
}
.warningMainBox::-webkit-scrollbar {
  display: none;
}
.warningMainBox33 {
  width: px2vw(400);
  height: px2vw(105);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
  background-image: url("../assets/00000_iSpt.png");
  background-size: contain;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  background-repeat: no-repeat;
  background-position: 0px 20px;
}
.waringtTitle {
  display: flex;
  width: 80%;
  justify-content: space-between;
  color: white;
  font-size: px2vw(12);
  margin-top: 10px;
}
.warningMainBox33Item {
  width: 90%;
  height: px2vw(60);
  // border: 1px solid red;
  display: flex;
  // justify-content: space-evenly;
}
.warningMainBox33Item .item1 {
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  background: linear-gradient(
    180deg,
    rgba(206, 238, 255, 1) 0%,
    rgba(0, 103, 199, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
  line-height: px2vw(34);
  text-align: center;
  line-height: px2vw(60);
  margin-left: px2vw(8);
}
.warningMainBox33Item .item2 {
  line-height: px2vw(60);
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(32);
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(255, 254, 233, 1) 0%,
    rgba(214, 167, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.warningMainBox33Item .item3 {
  line-height: px2vw(60);
  width: px2vw(60);
  text-align: center;
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(25);
  background: linear-gradient(
    180deg,
    rgba(255, 222, 198, 1) 0%,
    rgba(201, 84, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.warningMainBox33Item .item4 {
  line-height: px2vw(60);
  text-align: center;
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(28);
  background: linear-gradient(
    180deg,
    rgba(255, 211, 211, 1) 0%,
    rgba(221, 0, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.warningMainBoxItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: px2vw(380);
  height: px2vw(38);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.17) 0%,
    rgba(255, 255, 255, 0.17) 8.61%,
    rgba(255, 255, 255, 0.17) 90.61%,
    rgba(0, 0, 0, 0.17) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(27, 55, 67, 0.68);
  box-shadow: 0px 0px 9px rgba(160, 211, 233, 0.08) inset;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  line-height: px2vw(38);
  padding: 0px px2vw(5);
  margin-top: px2vw(10);
}
.warningBtn {
  width: px2vw(42);
  height: px2vw(19);
  background-image: url("../assets/Group_1321314701.png");
  background-size: cover;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(12);
  color: #c5f3f8;
  text-align: center;
  line-height: px2vw(19);
  background-size: cover;
}
.warningInfoBox {
  position: absolute;
  z-index: 999;
  pointer-events: auto;
  top: px2vw(420);
  left: px2vw(500);
  width: px2vw(400);
  height: px2vw(302);
  border: 1px solid rgba(54, 155, 188, 1);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
}
.warningInfoBox2 {
  // position: absolute;
  // z-index: 999;
  // top: px2vw(420);
  // left: px2vw(500);
  width: px2vw(400);
  // height: px2vw(302);
  border: 1px solid rgba(54, 155, 188, 1);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  color: white;
}
.leaflet-popup-content-wrapper {
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 1) 0%,
    rgba(11, 59, 73, 0.9) 17.16%,
    rgba(14, 92, 116, 0.9) 35.04%,
    rgba(14, 69, 86, 0.9) 64.84%,
    rgba(14, 50, 61, 0.9) 100%
  ) !important;
  color: white !important;
  border: 1px solid rgba(54, 155, 188, 1);
}
.warningInfoTitle {
  width: px2vw(400);
  height: px2vw(48);
  display: flex;
  align-items: center;
  color: rgba(227, 236, 255, 1);
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(16);
  line-height: px2vw(24);
  background: linear-gradient(
    89.93deg,
    rgba(35, 105, 138, 0) 0.06%,
    rgba(43, 133, 175, 0.93) 10.86%,
    rgba(35, 105, 138, 1) 72.9%,
    rgba(35, 105, 138, 0) 98.55%
  );
  /* width: 388px;
  height: 54px; */
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90.01deg,
    rgba(255, 255, 255, 0) 0.01%,
    rgba(255, 255, 255, 0) 18.18%,
    rgba(255, 255, 255, 0) 99.66%
  );
  padding: 0px px2vw(15);
}
.warningInfoTitle2 {
  width: 100%;
  height: px2vw(30);
  display: flex;
  align-items: center;
  color: rgba(227, 236, 255, 1);
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(16);
  line-height: px2vw(15);
  background: linear-gradient(
    89.93deg,
    rgba(35, 105, 138, 0) 0.06%,
    rgba(43, 133, 175, 0.93) 10.86%,
    rgba(35, 105, 138, 1) 72.9%,
    rgba(35, 105, 138, 0) 98.55%
  );
  /* width: 388px;
  height: 54px; */
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90.01deg,
    rgba(255, 255, 255, 0) 0.01%,
    rgba(255, 255, 255, 0) 18.18%,
    rgba(255, 255, 255, 0) 99.66%
  );
  padding: 0px px2vw(15);
}
.checkListSec .el-input--mini .el-input__inner {
  width: px2vw(100);
  height: px2vw(28);
  font-size: px2vw(14) !important;
}
.checkList2Sec .el-input--mini .el-input__inner {
  width: px2vw(150) !important;
  height: px2vw(28) !important;
  font-size: px2vw(14) !important;
  background-color: #40768b !important;
  color: white !important;
}
.el-radio__label {
  font-size: px2vw(14) !important;
}
.warningInfoMainBox {
  height: px2vw(250);
  width: 100%;
  /* background-color: #c5f3f8; */
}
.warningInfoMainBoxItem {
  height: px2vw(30);
  width: 100%;
  display: flex;
  margin-top: px2vw(5);
  /* background-color: #e7e2c0; */
}
.itemLeftBox {
  height: 100%;
  width: 30%;
  /* background-color: #c5f3f8; */
  line-height: px2vw(30);
  padding: 0px px2vw(15);
  text-align: right;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(16);
}
.itemRightBox {
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(16);
  line-height: px2vw(30);
}
.layerControllBox {
  border: 1px solid #2386a5;
  position: absolute;
  top: px2vw(130);
  right: px2vw(440);
  z-index: 999;
  pointer-events: auto;
  width: px2vw(222);
  /* height: 178px; */
  /* background-image: url("../assets/Rectangle_19479.png"); */
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  padding: px2vw(10) px2vw(10) px2vw(25) px2vw(10);
}
.layerControllTitle {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(18);
  /* padding: 5px 10px; */
}
.openBottomlaryerbtn {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(14);
}
.layerSelectBox {
  height: 20px;
  width: 100%;
  margin-top: px2vw(5);

  /* background-color: #c5f3f8; */
}
.mylayerSelectBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-radio {
  margin-right: px2vw(10) !important;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #32dcfe !important;
}
/* 选中后小圆点的颜色 */
.el-radio__input.is-checked .el-radio__inner {
  background: #32dcfe !important;
  border-color: #32dcfe !important;
}
.el-radio__label {
  color: white !important;
}
// .el-input__inner {
//   background-color: #1e4e4e !important;
//   color: white !important;
// }
.el-checkbox {
  margin-right: px2vw(10) !important;
}
.el-checkbox__label {
  color: white !important;
}

.timelineBox {
  box-sizing: border-box;
  width: px2vw(860);
  height: px2vw(50);
  position: absolute;
  bottom: px2vw(180);
  pointer-events: auto;
  left: px2vw(530);
  z-index: 999;
  background: linear-gradient(
    90deg,
    rgba(0, 51, 51, 0.72) 0%,
    rgba(0, 149, 149, 0.43) 49.75%,
    rgba(0, 51, 51, 0.72) 100%
  );
  // transform: translateX(-430px);
  border: 2px solid #2386a5;
  display: flex;
}
.playBtnBox {
  height: px2vw(50);
  width: px2vw(50);
  /* background-color: #32dcfe; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.isplayingBtn {
  width: px2vw(40);
  height: px2vw(40);
}
.el-select .el-input .el-select__caret {
  font-size: px2vw(14) !important;
}
.el-input--mini .el-input__icon {
  line-height: px2vw(28) !important;
}
.el-tag--small {
  height: px2vw(24) !important;

  padding: 0 px2vw(8) !important;
  line-height: px2vw(22) !important;
  font-size: px2vw(12) !important;
}
.timeline {
  height: px2vw(50);
  width: px2vw(780);
  // background-color: #2386a5;
  margin-left: px2vw(20);
}
.el-slider__marks-text {
  position: absolute;
  transform: translateX(-50%);
  font-size: px2vw(14) !important;
  color: #909399;
  margin-top: px2vw(15) !important;
}
.el-slider__button {
  width: px2vw(16) !important;
  height: px2vw(16) !important;
  border: px2vw(2) solid #409eff;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.el-slider__runway {
  width: 100%;
  height: px2vw(6) !important;
  margin: px2vw(16) 0 !important;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.lendgenBox {
  /* height: 204px; */
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.52) 0%,
    rgba(11, 59, 73, 0.47) 17.16%,
    rgba(14, 92, 116, 0.36) 35.04%,
    rgba(14, 69, 86, 0.45) 64.84%,
    rgba(14, 50, 61, 0.5) 100%
  );
  padding: px2vw(10) 0px;
}
.listNewBox {
  position: absolute;
  bottom: px2vw(10);
  right: px2vw(250);
  z-index: 999;
  width: px2vw(100);
}
.lendgenBoxTitle {
  height: px2vw(30);
  width: 100%;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
}
.showNumSwitch {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  font-size: px2vw(12);
}
.el-switch__core {
  width: px2vw(40) !important;
  height: px2vw(20) !important;
}
.el-switch__core:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  transition: all 0.3s;
  width: px2vw(16) !important;
  height: px2vw(16) !important;
  background-color: #fff;
}
.colorListBox {
  width: 100%;
  /* padding: 10px; */
  /* background-color: #32dcfe; */
}
.colorListBoxItem {
  height: px2vw(15);
  width: 100%;
  display: flex;
  justify-content: space-around;
  color: white;
  margin-top: px2vw(5);
}
.colorBox {
  width: 40%;
  height: px2vw(15);
  background-color: red;
}
.colorLable {
  height: px2vw(15);
  width: px2vw(50);
  text-align: center;
  line-height: px2vw(15);
}
.optionSet {
  width: px2vw(100);
  height: px2vw(30);
  background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
  margin-bottom: 5px;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
}
.optionSet2 {
  width: px2vw(150);
  height: px2vw(30);
  background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
  border-bottom: 2px solid rgba(28, 132, 153, 1);
  margin-bottom: 5px;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
  position: absolute;
  bottom: px2vw(50);
  right: px2vw(250);
  z-index: 9999;
}
.closeBoxImg {
  position: absolute;
  top: 0;
  right: 0;
  width: px2vw(30);
  height: px2vw(30);
}
.otherLaryerControllBox {
  height: px2vw(80);
  // width: px2vw(207);
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(400);
  right: px2vw(0);
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  // align-content: flex-end;
  align-items: flex-end;
}
.myLaryerControllBox {
  height: px2vw(600);
  width: px2vw(307);
  pointer-events: auto;
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(272) !important;
  right: px2vw(0);
  display: flex;
  flex-direction: column;
  // align-content: flex-end;
  align-items: flex-end;
}
.layerChooseBoxTitle {
  width: px2vw(100);
  height: px2vw(20);
  padding-right: px2vw(8);
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  line-height: px2vw(16);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 9.38%,
    rgba(135, 154, 181, 1) 90.62%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  // text-align: right;
  justify-content: end;
}
.layerradioBox {
  margin-top: px2vw(15);
  display: flex;
  justify-content: end;
  align-items: center;
}
.testRadio {
  // display: block !important;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.layerCHooseItemBox {
  margin-top: px2vw(15);
  padding-right: px2vw(8);
  // display: flex;
  // justify-content: end;
  // flex-direction: column;
}
.testradiobox {
  width: fit-content;
  height: px2vw(32);
  display: flex;
  align-items: center;
  padding: 0 px2vw(10);
  margin-top: px2vw(5);
  border-radius: px2vw(49);
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  justify-content: end;
}
.testradiobox3 {
  color: white;
  width: auto;
  height: px2vw(32);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 px2vw(10);
  margin-top: px2vw(5);
  border-radius: px2vw(49);
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  // margin-left: px2vw(10);
  // margin-right: px2vw(10);
}
.testradiobox2 {
  color: white;
  width: auto;
  height: px2vw(32);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 px2vw(10);
  margin-top: px2vw(5);
  border-radius: px2vw(49);
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  margin-left: px2vw(5);
}
.leaflet-popup-close-button {
  font: 27px / 24px Tahoma, Verdana, sans-serif !important;
  color: white !important;
}
.showRadioLayer {
  height: px2vw(32);
  line-height: px2vw(32);
  // color: ;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  color: white;
  width: px2vw(32);
  text-align: center;
  font-size: px2vw(32);
  margin-top: px2vw(5);
  border-radius: 5px;
  margin-left: 5px;
}
.waringPrintPop {
  height: px2vw(300);
  width: px2vw(300);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  position: absolute;
  top: px2vw(300);
  left: px2vw(500);
  z-index: 9999;
}
#roundEchartBox {
  height: 100%;
  width: 100%;
}

// .el-table--enable-row-hover .el-table__body tr:hover > td {
//   background-color: #212e3e !important;
// }
.warningBoxfTable {
  width: 100%;
  // height: 30px;
  // background-color: red;
  display: flex;
  border: 1px solid #2b616d;
}
.warningBoxfTableLeft {
  height: px2vw(50);
  width: 20%;
  // background-color: #1e4e4e;
  text-align: center;
  line-height: px2vw(50);
  color: white;
  border-right: 1px solid #2b616d;
}
.warningBoxfTableRight {
  height: px2vw(50);
  width: 80%;
}
.warningBoxfTableRight .Topbox {
  height: px2vw(25);
  width: 100%;
  // background-color: #2386a5;
  text-align: center;
  line-height: px2vw(25);
  color: white;
  border-bottom: 1px solid #2b616d;
}
.warningBoxfTableRight .bottombox {
  height: px2vw(25);
  width: 100%;
  line-height: px2vw(25);
  color: white;
  display: flex;
}
.bottombox .bottomboxItem {
  width: 20%;
  height: 100%;
  text-align: center;
  border: 1px solid #2b616d;
  font-size: px2vw(12);
}
.showMainTbaleBox {
  height: calc(100% - px2vw(50));
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // overflow: auto;
  // background-color: red;
  // position: absolute;
  // z-index: 9999;
}
.showMainTbaleBox::-webkit-scrollbar {
  display: none;
}
.showMainTbaleBoxItem {
  width: 100%;
  height: px2vw(30);
  margin-bottom: px2vw(10);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  display: flex;
}
.showMainTbaleBoxItemLet {
  width: 20%;
  height: 100%;
  text-align: center;
  line-height: px2vw(30);
  color: white;
  font-size: px2vw(12);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showMainTbaleBoxItemrig {
  width: 80%;
  height: 100%;
  display: flex;
}
.showMainTbaleBoxItemrig .item {
  width: 20%;
  height: 100%;
  // background-color: #09b1e1;
  text-align: center;
  color: white;
  line-height: px2vw(30);
}
.myareaNameBox {
  // background-image: url("../assets/Group_1321314690_1.png");
  // -webkit-text-stroke: 1px black;
  width: px2vw(50);
  height: px2vw(50);
  background-size: 100% 100%;
  line-height: px2vw(25);
  color: white;
  position: relative;
  z-index: 999;
}
.weatherHounrListBox {
  width: px2vw(400);
  height: px2vw(100);
  display: flex;
  justify-content: space-around;
  align-items: center;
  // background-color: red;
}
.weatherHounrListBoxItem {
  width: px2vw(40);
  height: px2vw(80);
  // background-color: red;
  text-align: center;
  font-size: px2vw(12);
  color: white;
}
.warnTableBoxHeaderBox {
  height: px2vw(15);
  width: 100%;
  // background-color: red;
  font-size: px2vw(12);
  line-height: px2vw(15);
  color: rgba(205, 247, 255, 1);
  font-family: "Microsoft YaHei UI";
  font-weight: 400;
}
.warnTableBoxheader22 {
  width: 100%;
  height: px2vw(30);
  border-bottom: 1px solid rgba(30, 92, 96, 1);
  background: rgba(24, 88, 96, 0.5);
  margin-top: px2vw(10);
  display: flex;
}
.warnTableBoxheader33 {
  width: 100%;
  height: px2vw(30);
  border-bottom: 1px solid rgba(30, 92, 96, 1);
  background: rgba(14, 53, 62, 0.2);
  // margin-top: px2vw(10);
  display: flex;
}
.warnTableBoxheader44 {
  width: 100%;
  height: px2vw(30);
  border-bottom: 1px solid rgba(30, 92, 96, 1);
  background: rgba(24, 88, 96, 0.5);
  // margin-top: px2vw(10);
  display: flex;
}
.warnTableBoxheader22Item1 {
  width: 40%;
  height: 100%;
  line-height: px2vw(30);
  padding: 0 20px;
  color: rgba(255, 255, 255, 1);
  font-family: "Microsoft YaHei UI";
  font-weight: 400;
  font-size: 12px;
}
.warnTableBoxheader22Item2 {
  width: 40%;
  height: 100%;
  line-height: px2vw(30);
  // padding: 0 20px;
  color: rgba(255, 255, 255, 1);
  font-family: "Microsoft YaHei UI";
  font-weight: 400;
  font-size: 12px;
}
.warnTableBoxheader22Item {
  width: 12%;
  height: 100%;
  line-height: px2vw(30);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-family: "Microsoft YaHei UI";
  font-weight: 400;
  font-size: 12px;
}
.tableCellBox {
  height: calc(100% - px2vw(60));
  width: 100%;
  // background-color: red;
  overflow-y: auto;
  overflow-x: hidden;
}
.tableCellBox::-webkit-scrollbar {
  display: none;
}
.testBox {
  width: 74px;
  height: 29.6px;
  border-width: 1.5px;
  border-style: solid;
  border-image-source: linear-gradient(
    180deg,
    rgba(0, 137, 250, 0.1) 0%,
    rgba(0, 137, 250, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  box-shadow: 0px 1px 3px rgba(0, 137, 250, 1);
}
// .mywivewBox2 {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   // height: 100%;
//   object-fit: cover;
//   min-height: 100%;
//   // z-index: -1;
//   // transform: translate(-50%, -50%);
// }
.text222 {
  height: 100px;
  width: 300px;
  position: absolute;
  top: 300px;
  left: 500px;
  // background-color: red;
  z-index: 9999;
  border: 1px solid red;
}
.weatyherListTextBox {
  // color: #32dcfe;
}
.temTetx {
  // font-size: 9px;
  margin-top: px2vw(5);
}
.weatyherListTextBox img {
  width: px2vw(40);
  height: px2vw(40);
}
.showRainBox {
  height: px2vw(40);
  width: px2vw(100);
  background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
  color: white;
  position: absolute;
  top: px2vw(130);
  left: px2vw(600);
  z-index: 1000;
  line-height: px2vw(40);
  text-align: center;
  border-radius: 5px;
}
.rainBox {
  height: px2vw(550);
  width: px2vw(1000);
  background-color: #2b616d;
  position: absolute;
  top: px2vw(150);
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  border-radius: px2vw(15);
}
.rainBoxTitle1 {
  height: px2vw(40);
  width: 100%;
}
.climg {
  height: px2vw(30);
  width: px2vw(30);
  position: absolute;
  right: px2vw(5);
  top: px2vw(5);
}
.titleTetxBox {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: px2vw(40);
  color: white;
  font-size: 20px;
}
.dashLine {
  stroke-dasharray: 10;
}
</style>